var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.75,444.84c130.86-.62,277.64-.62,408.5,0-130.86.61-277.64.61-408.5,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.87,417.69c-4.21,2.19-8.88,4.72-13.75,3.63-4.5-1-9.25-3.43-10.91-8-.47-1.31-.56-2.22,1-2.33,2.43-.16,5.09,1.35,7.26,2.25a48.35,48.35,0,0,0,8.63,2.81c2.08.44,4.21.67,6.3,1.06.27,0,.53.09.79.15l.3.06.13-.05a.21.21,0,0,1,.22,0l.07.05A.26.26,0,0,1,278.87,417.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,417.3c-3.8,1.74-7.79,3.85-12,2.73a19.28,19.28,0,0,1-5.53-2.59c-.77-.5-3.08-2-2.95-3.09.26-2,7.71,2.08,8.61,2.37a20.31,20.31,0,0,0,10.38.36c.27,0,.53.09.79.15a22.41,22.41,0,0,1-7.39.58c-3.44-.32-6-2-9.19-3.17-.68-.26-2.81-1.21-2.85,0,0,.82,2.23,2.29,2.71,2.6a19.17,19.17,0,0,0,5.24,2.46c4.25,1.19,8.26-.83,12.13-2.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.48,419.17c0,.19.09.37.13.55v0a.13.13,0,0,1,0,.12.19.19,0,0,1-.27,0,.19.19,0,0,1-.05-.1s0,0,0-.08,0-.11,0-.16h0l0,0c-2.11-2.47-3.82-5.28-6-7.73s-4.27-4.55-6.14-7.05c-1.18-1.58-6.56-9.75-2.19-10.5,1.94-.33,4.29,1.59,5.64,2.76a19.84,19.84,0,0,1,4.42,5.6C280.76,407.76,281.12,413.55,282.48,419.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.52,407.7a23,23,0,0,0-3.45-5.64c-.49-.59-2.86-3.41-3.91-2.81-.68.38-.14,1.83,0,2.32.68,2.06,2.26,3.75,3.54,5.46a89,89,0,0,1,7,11c.08.26.16.53.25.79s.15.43.22.65,0,.15.07.23l.06.17a.2.2,0,0,0,.27,0c-.06-.17-.11-.34-.16-.51l.2.39s0,0,0,0l-.12-.44s0-.07,0-.1l-.32-.65A97,97,0,0,0,278.52,407.7Zm2.91,9.45c-1.2-2.24-2.52-4.42-3.92-6.54-1.14-1.71-2.35-3.36-3.6-5a22.34,22.34,0,0,1-2-2.86c-.41-.78-1.7-3.79.69-2.69,1.73.81,3.34,3.51,4.25,5.07a33,33,0,0,1,2.49,5.48C280.14,412.77,280.77,415,281.43,417.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.4,429.84h0l-.15.09c-4,1.67-9.06,4.53-13.56,3.49-3.32-.76-7.49-3.42-8.26-7-.86-4,6.1-2,7.89-1.59a133.6,133.6,0,0,1,14.06,4.77l.09,0h0C290.54,429.7,290.48,429.77,290.4,429.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48,429.66l-.88-.11c-3.35-.39-6.69-.92-10-1.63-.83-.17-7.11-2-7.11-.27,0,1,2.29,2.07,3,2.43a13.18,13.18,0,0,0,4.24,1.24c3.39.38,6.73-.78,10.06-1.4l.47-.1.09,0h0C290.48,429.77,290.54,429.7,290.48,429.66Zm-8.82,1.46a13.33,13.33,0,0,1-4.47-.67c-1-.31-4.39-1.55-4.24-2.81.09-.67.49-.52,1.26-.52a9.47,9.47,0,0,1,1.06.09c.86.12,1.71.33,2.55.53,1.49.35,3,.66,4.48.93,2.45.47,4.92.82,7.4,1.1C287,430.17,284.38,431.06,281.66,431.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.71,418.35a25.73,25.73,0,0,1-1.12,14.93l-.06.08a.2.2,0,0,1-.23,0,.18.18,0,0,1-.09-.23l.1-.3c-1.89-5.64-3.7-11.27-5.7-16.88-.47-1.32-3.31-9.8-.23-9.67,1.91.08,3.58,3.31,4.41,4.73A26.08,26.08,0,0,1,293.71,418.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.88,411.88c-.35-.38-.8-.73-1.15-.18-.67,1.06.75,5,1.09,6.13,1.39,4.61,2.34,9.23,3.31,13.93.08.39.17.79.25,1.19l-.08.43a.18.18,0,0,0,.23,0,.5.5,0,0,0,0-.12c0-.19.09-.39.12-.59h0a30.36,30.36,0,0,0,.28-9.41,29.68,29.68,0,0,0-1.37-5.82C290.93,415.68,290.15,413.26,288.88,411.88Zm3.59,20.49c0,.09,0,.18,0,.28,0-.17,0-.33-.07-.5a86.75,86.75,0,0,0-2.27-10.92c-.52-1.82-1.15-3.6-1.6-5.43-.18-.77-.8-2.95-.37-3.56s.79.19,1.07.61.47.9.63,1.2A30,30,0,0,1,292.47,432.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.72,444.46l-.79.38c-.34-.69-.68-1.37-1-2-1.42-2.74-2.86-5.47-4.36-8.17-.85-1.55-1.71-3.07-2.62-4.55a1.19,1.19,0,0,1-.09-.15l-.23-.37-.25-.38a37.35,37.35,0,0,0-7.57-8.95c-1-.85-2.07-1.64-3.14-2.42l-.31-.22-.08-.06-.32-.23c-.09-.05-.16-.11-.25-.17-3.33-2.32-6.86-4.38-10.29-6.51-1-.61-2-1.22-2.94-1.85a.78.78,0,0,1-.18-.11,1.79,1.79,0,0,1-.22-.13c-4.33-2.72-8.64-5.49-13-8.1-.16-.09,0-.33.17-.23,2.94,1.71,5.93,3.35,8.91,5l1.19.67c.79.44,1.57.87,2.35,1.32,1.56.88,3.11,1.77,4.65,2.69a125.4,125.4,0,0,1,12.79,8.24c.29.23.59.46.88.71s.37.29.54.45l.63.52a40.17,40.17,0,0,1,8.52,11.09c.16.28.33.57.48.87.07.13.15.26.23.39a1.51,1.51,0,0,0,.11.22l.15.28h0l.1.21c.14.25.27.5.4.75,1.44,2.73,2.84,5.48,4.23,8.23C297.8,442.71,298.26,443.59,298.72,444.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.27,405.19c-3.52-1.86-9.11-6.51-7.43-11.11a3.74,3.74,0,0,1,4.33-2.47c2.24.41,4.08,2.34,5.53,4,3.85,4.36,7.27,9,11.44,13.13,0,0,.35.35.45.44s-.06.2-.15.12l-.41-.4C260.43,408,255.44,407.4,251.27,405.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.17,408.71l-.09-.07a40,40,0,0,1-3.79-2.77,80.52,80.52,0,0,1-7-6.8c-.86-.92-4.93-5.48-5.82-2.47-.37,1.27.5,2.79,1.14,3.82a14.72,14.72,0,0,0,4,4.19,26.86,26.86,0,0,0,10.67,4l.52.11.14.09.09.06a.11.11,0,0,0,.07,0,.13.13,0,0,0,.13-.15A.08.08,0,0,0,265.17,408.71Zm-1.12-.19a31.43,31.43,0,0,1-8.93-3.18,16.68,16.68,0,0,1-3.88-3.07,13.58,13.58,0,0,1-1.35-1.75,9.62,9.62,0,0,1-.8-1.44c-.48-1.11-.6-2.52,0-2.94s1.22-.18,2.18.48c.32.22.63.48.93.73a29.43,29.43,0,0,1,2.09,2.09c1.11,1.19,2.23,2.37,3.39,3.51q1.18,1.17,2.43,2.25a40.07,40.07,0,0,0,4.53,3.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.36,403.46c-1.69,2.71-3.56,5.3-5.45,7.87-1.07,1.46-2.17,2.9-3.24,4.37s-2.54,3.17-2.89,5.18h0a1.57,1.57,0,0,1-.1.26l0,0a.25.25,0,0,1-.35-.24l0-.13a.43.43,0,0,0,0-.05,7.14,7.14,0,0,1,.07-1.78,41,41,0,0,1,.49-4.82,39.85,39.85,0,0,1,2.71-9.52,33,33,0,0,1,4.54-7.6c1.48-1.85,3.65-4.63,5.94-5.5,2.08-.79,2.19,2.06,2.05,3.42C419.82,398,418,400.9,416.36,403.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.61,396.17c-1.05-.49-3.38,2.55-4.43,3.84a31.93,31.93,0,0,0-4.16,6.64,41.59,41.59,0,0,0-3.63,13.53c0,.19-.05.38-.06.57a.43.43,0,0,1,0,.05.51.51,0,0,0,0,.13.24.24,0,0,0,.34.24c.1-.39.2-.76.33-1.13s.22-.67.34-1A54.83,54.83,0,0,1,410.78,409C413.14,405.2,418,396.82,416.61,396.17Zm-11.78,23.46c-.17.49-.31,1-.43,1.48l.15-1.14a46.15,46.15,0,0,1,3.14-12,32.57,32.57,0,0,1,3.39-6.11,29,29,0,0,1,2.35-2.93c.35-.39,2.43-2.87,3-2.43.41.32-.67,2.92-.69,3-.2.52-.44,1-.69,1.55-.5,1.05-1.06,2.07-1.63,3.08-1.26,2.18-2.64,4.3-4,6.45A43,43,0,0,0,404.83,419.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.19,419.05c-3.66,2.86-8.23,4.24-12.72,5.15-2.41.49-4.84.87-7.25,1.3A32.11,32.11,0,0,0,402.8,427a1.92,1.92,0,0,0-.27.11,8.3,8.3,0,0,0-1.6.89.11.11,0,0,1-.12,0l-.14.14s-.09,0-.07-.05a1.74,1.74,0,0,0,.11-.18h0a.13.13,0,0,1,.06-.15s0,0,.06-.05l.11-.17c2.58-4.14,7.7-7.15,11.86-9.33s8.75-3.68,13.48-3.37c1.18.08,4,.07,4.61,1.37S430,418.44,429.19,419.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.21,417.69c-.49-1.34-4.23-.33-5.15-.11a49.3,49.3,0,0,0-8.08,2.83,44.55,44.55,0,0,0-11.88,7h0l-.15.08-.11.17s0,0-.06.05a.13.13,0,0,0-.06.15l.21-.09c.52-.26,1.06-.5,1.6-.72l.27-.12a96.08,96.08,0,0,1,11.74-3.49,45.67,45.67,0,0,0,8-2.83C423.24,420.31,426.62,418.81,426.21,417.69Zm-1.77,1.62c-4,2.72-9.23,3.65-13.84,4.85a49.69,49.69,0,0,0-9.12,3.08A46.68,46.68,0,0,1,412.34,421a64.33,64.33,0,0,1,6.68-2.57,25.46,25.46,0,0,1,3.76-.92,10,10,0,0,1,2.33-.14C426.55,417.61,425.13,418.84,424.44,419.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.18,436.61a.25.25,0,0,1-.25,0l0,.1s0,.07-.06.08-.07,0-.09,0c-1.88-5.27-3.27-11.26-2.83-16.87a22,22,0,0,1,1.66-6.91c.64-1.49,1.94-4.5,3.7-5,3.55-1,1.62,9.26,1.32,10.81-.54,2.81-1.31,5.57-1.91,8.38-.64,3.07-1.06,6.17-1.49,9.28A.19.19,0,0,1,396.18,436.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.18,436.61c0-.3-.06-.59-.07-.89a47.07,47.07,0,0,1,1.12-14.45,44.11,44.11,0,0,0,1.29-7.21c0-.6.29-2.85-1-2.25-.68.31-2,4.19-2.3,5.22a30.16,30.16,0,0,0-.86,7.26,49.19,49.19,0,0,0,1.45,12.18c0,.11.05.23.08.34s.07,0,.06-.08a.29.29,0,0,1,0-.09A.27.27,0,0,0,396.18,436.61Zm-1.51-10.28a34.53,34.53,0,0,1,.39-7.25,25.53,25.53,0,0,1,.65-2.82,16,16,0,0,1,.78-2.13c.79-1.67,1.12-2,1.43-2s.35.34.38,1.57a12.61,12.61,0,0,1-.23,2.37c-.2,1.11-.43,2.21-.68,3.31-.49,2.2-1,4.39-1.34,6.62a35.92,35.92,0,0,0-.18,9.66A55.36,55.36,0,0,1,394.67,426.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.67,433.1a14,14,0,0,1-4.59,3.77c-3.46,1.94-7.28,3.11-10.86,4.8-.54.25-1.07.52-1.6.8-.05,0-.6.52-.57.47s.15-.23.41-.58h0c1.27-1.76,5.18-7,8.08-9.31a28.51,28.51,0,0,1,5.81-3.71c1-.44,3.27-1.33,4.27-.44S412.27,432.25,411.67,433.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.33,431.05c-.88-1.34-6.7,2.87-7.47,3.41a40.3,40.3,0,0,0-7.65,7c-.26.3-.5.6-.75.91l-.41.57s.52-.43.58-.46l.27-.15,1.31-.65c2.34-1.43,4.72-2.82,7-4.3a36.49,36.49,0,0,0,4.76-3.54C408.34,433.53,410.72,431.63,410.33,431.05Zm-1.09,1.44c-4.05,4.13-9.45,6.37-14.22,9.5l-.23.15c.1-.11.19-.23.29-.33a45.22,45.22,0,0,1,6.25-5.89,45.74,45.74,0,0,1,4.33-2.94,22.07,22.07,0,0,1,2.51-1.41c.38-.16,1.45-.57,1.64-.33S409.5,432.21,409.24,432.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,398c-7.58,6.73-19,6.2-27,12.4l0,0c-.25.19-.48.39-.72.59a.19.19,0,0,1-.3-.09.14.14,0,0,1,.05-.14l.17-.15a48.36,48.36,0,0,1,12-12.38c3.91-2.91,8.48-5.21,13.43-5.4,1.22-.05,3.64-.23,4.36,1.12S443.92,397.16,443,398Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.52,396.82c-.31-.56-1.21-.47-1.71-.45a15.24,15.24,0,0,0-3.67.62,25.47,25.47,0,0,0-6.89,3.22,53.06,53.06,0,0,0-10.15,8.19c-.67.72-1.31,1.46-1.92,2.24-.07.09-.14.19-.22.28a.19.19,0,0,0,.3.09c.22-.2.45-.38.69-.57,0,0,0,0,.06-.05a31.26,31.26,0,0,1,4.85-3.6,72.26,72.26,0,0,1,8.51-4C430.51,402.33,440.59,398.75,439.52,396.82ZM438,398.5c-2,1.47-4.52,2.28-6.81,3.27s-4.63,2-6.93,3a35.74,35.74,0,0,0-5.24,2.9,28.05,28.05,0,0,0-3.89,3.13,36.66,36.66,0,0,1,3.39-3.55l.05,0a69.72,69.72,0,0,1,6.84-5.44l.09-.07a32.21,32.21,0,0,1,6.69-3.79,18.68,18.68,0,0,1,4-1.12c1.57-.22,2.86-.24,3,.29C439.31,397.43,438.63,398.07,438,398.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.59,401.94c-2.21,1.87-4.38,3.79-6.54,5.72l-3,2.73s-.05,0-.06.05l-1.1,1a82.85,82.85,0,0,0-9.59,9.42,37.53,37.53,0,0,0-3.82,5.93c-.11.22-.22.43-.34.64h0c-.06.12-.12.24-.17.36a1.24,1.24,0,0,0-.1.2c-.93,1.82-1.76,3.68-2.56,5.5-1.12,2.54-2.06,5.14-3,7.74a2.09,2.09,0,0,0-.08.23c0,.12-.08.24-.13.36L395,442l-.12.33q-.43,1.26-.9,2.52l-.77-.36a55.64,55.64,0,0,1,2.51-7.86,1,1,0,0,1,.07-.15c.09-.25.19-.51.3-.75s.24-.61.37-.91c.31-.74.62-1.46.93-2.18a58.53,58.53,0,0,1,6.64-12l.24-.29a.64.64,0,0,1,.1-.13l.16-.21.28-.34c.16-.2.34-.39.5-.58l.16-.18a87.73,87.73,0,0,1,9-8.27l1.69-1.42.94-.78,1.45-1.16.05,0c2.27-1.82,4.58-3.6,6.84-5.44C425.55,401.68,425.69,401.85,425.59,401.94Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.47,62h-169a17.26,17.26,0,0,0-17.1,17.42v348a17.27,17.27,0,0,0,17.1,17.42H243.47a17.28,17.28,0,0,0,17.12-17.42v-348A17.27,17.27,0,0,0,243.47,62Zm6.43,354.67c0,9.16-6.86,16.57-15.32,16.57H83.34c-8.48,0-15.34-7.41-15.34-16.57V92.6C68,73.94,74.86,73,83.34,73h30.29c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.09,5.83H194c3.94,0,7.09,0,7.09-5.83V77.51c0-2.48,1.42-4.48,3.21-4.48h30.3C243,73,249.9,75.51,249.9,92.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5,77.15H149.39A1.18,1.18,0,0,1,148.21,76h0a1.18,1.18,0,0,1,1.18-1.18H168.5A1.18,1.18,0,0,1,169.68,76h0A1.18,1.18,0,0,1,168.5,77.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,92.6V416.66c0,9.16-6.86,16.57-15.32,16.57H83.34c-8.48,0-15.34-7.41-15.34-16.57V92.6C68,73.94,74.86,73,83.34,73h30.29c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.09,5.83H194c3.94,0,7.09,0,7.09-5.83V77.51c0-2.48,1.42-4.48,3.21-4.48h30.3C243,73,249.9,75.51,249.9,92.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89,92.6v34.18H68V92.6C68,73.94,74.85,73,83.33,73h30.3c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83H194c3.94,0,7.1,0,7.1-5.83V77.51c0-2.48,1.42-4.48,3.21-4.48h30.29C243,73,249.89,75.51,249.89,92.6Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.41 118.84 81.04 113.81 86.41 108.77 87.25 109.66 82.82 113.81 87.25 117.96 86.41 118.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,111.73a1.06,1.06,0,1,1-1.06-1.06A1.06,1.06,0,0,1,236.87,111.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,115.49a1.06,1.06,0,1,1-1.06-1.06A1.06,1.06,0,0,1,236.87,115.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,119.25a1.06,1.06,0,1,1-1.06-1.06A1.06,1.06,0,0,1,236.87,119.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.4,80.3l-.29.3-.17.16a4,4,0,0,0-5.64,0,1.29,1.29,0,0,0-.16-.17l-.29-.29h0l0,0,.37-.33a4.7,4.7,0,0,1,.85-.54,4.14,4.14,0,0,1,1.14-.38,5,5,0,0,1,.56-.08h.5l.39,0a4.77,4.77,0,0,1,1,.25,4.66,4.66,0,0,1,1.37.8l.31.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,81.68c-.16-.15-.31-.3-.46-.46a3.33,3.33,0,0,1,4.71,0l-.47.46a2.61,2.61,0,0,0-1.89-.78A2.65,2.65,0,0,0,103.23,81.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,82.14c-.15.16-.3.31-.46.46a1.34,1.34,0,0,0-1-.4,1.32,1.32,0,0,0-1,.41c-.15-.16-.3-.31-.46-.46A2,2,0,0,1,106.55,82.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54,83a.42.42,0,0,1-.42.42.41.41,0,0,1-.41-.42.41.41,0,0,1,.41-.41A.41.41,0,0,1,105.54,83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.86,81.19a1.21,1.21,0,1,1,1.2,1.2A1.21,1.21,0,0,1,79.86,81.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.66,81.19a1.21,1.21,0,1,1,1.2,1.2A1.21,1.21,0,0,1,83.66,81.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45,81.19a1.21,1.21,0,1,1,1.21,1.2A1.21,1.21,0,0,1,87.45,81.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.25,81.19a1.21,1.21,0,1,1,1.21,1.2A1.21,1.21,0,0,1,91.25,81.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,81.19a1.21,1.21,0,1,1,1.2,1.2A1.21,1.21,0,0,1,95.05,81.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,83.82h-9.81V79.27h9.81Zm-9.31-.5h8.81V79.77h-8.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.25,
    y: 80.05,
    width: 6.33,
    height: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.26,
    y: 80.33,
    width: 0.87,
    height: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.64 413.42 94.25 413.42 94.25 419.77 91.67 419.77 91.67 416.53 87.09 416.53 87.09 419.77 84.51 419.77 84.51 413.42 83.13 413.42 89.38 406.95 95.64 413.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 406.95,
    width: 15.08,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 412.28,
    width: 15.08,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 417.61,
    width: 15.08,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles-2--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.61 276.05 192.33 276.05 192.33 235.2 94.61 235.2 94.61 235.2 94.61 276.05 94.61 276.05",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 242.26,
    width: 82.82,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 246.45,
    width: 58.91,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 254.84,
    width: 73.35,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 259.03,
    width: 82.82,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 263.22,
    width: 82.82,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 267.41,
    width: 50.92,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.33 247.25 192.33 235.2 206.87 235.2 192.33 247.25",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.61 381.89 192.33 381.89 192.33 353.04 94.61 353.04 94.61 353.04 94.61 381.89 94.61 381.89",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.33 365.09 192.33 353.04 206.87 353.04 192.33 365.09",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 360.11,
    width: 82.82,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 364.3,
    width: 58.91,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 372.68,
    width: 73.35,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.08,
    y: 147.45,
    width: 97.72,
    height: 34.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.08 159.5 131.08 147.45 116.53 147.45 131.08 159.5",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 153.81,
    width: 63.57,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 158.01,
    width: 82.82,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 162.2,
    width: 82.82,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 166.39,
    width: 73.7,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 170.58,
    width: 82.82,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 174.77,
    width: 52.74,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.08,
    y: 187.49,
    width: 97.72,
    height: 25.56,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 193.86,
    width: 82.62,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 198.05,
    width: 62.27,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 202.24,
    width: 71.78,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.68,
    y: 206.43,
    width: 47.97,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.08 199.54 131.08 187.49 116.53 187.49 131.08 199.54",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.08,
    y: 296.31,
    width: 97.72,
    height: 36.03,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.08 308.36 131.08 296.31 116.53 296.31 131.08 308.36",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 315.12,
    width: 76.42,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 319.31,
    width: 67.56,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 306.74,
    width: 70.14,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 302.55,
    width: 81.39,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 323.5,
    width: 71.11,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--robot-avatar--inject-7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 222.13,
    cy: 256.88,
    r: 17.25,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.07,262.46h0",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,269.13a.2.2,0,0,1,0,.07s0,.07,0,.11h0c0,.21-.06.47-.09.77s-.09.84-.14,1.33-.09.86-.14,1.32l0,.25-.31.11a1.92,1.92,0,0,1-.31.11,17.31,17.31,0,0,1-8.44.68l-.12,0a15.76,15.76,0,0,1-2.58-.67,1.76,1.76,0,0,1-.3-.1L216,273l0-.26c0-.46-.1-.9-.14-1.31s-.09-.94-.14-1.32-.06-.58-.09-.79h0s0-.07,0-.1a.2.2,0,0,1,0-.07.49.49,0,0,1,0-.12.47.47,0,0,1,.06-.21.57.57,0,0,1,.33-.3,21.44,21.44,0,0,1,3.49-.86l.4-.06h0l.49-.06h0l.6-.06h.1c.39,0,.74-.05,1.06-.05h0c.33,0,.71,0,1.11.05h.09l.66.07h0l.53.07h0l.23,0a20.93,20.93,0,0,1,3.53.87.54.54,0,0,1,.34.32.37.37,0,0,1,.06.21A.34.34,0,0,1,228.74,269.13Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25,273.89l-.12,0-.07-2.56-.05-1.76,0-1.76.09,1.76.08,1.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.43,269.07a.3.3,0,0,1-.19.1A.27.27,0,0,1,218,269a.26.26,0,0,1,.18-.3.26.26,0,0,1,.21,0,.25.25,0,0,0-.23-.09.39.39,0,0,0-.23.13.37.37,0,0,0-.06.27.33.33,0,0,0,.16.22.32.32,0,0,0,.48-.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,271.28a.27.27,0,0,1-.28-.22.27.27,0,0,1,.18-.31.31.31,0,0,1,.21,0,.29.29,0,0,1,.13.19.33.33,0,0,0-.36-.27.39.39,0,0,0-.23.13.4.4,0,0,0-.06.27.36.36,0,0,0,.16.22.39.39,0,0,0,.26,0,.31.31,0,0,0,.23-.24l0,.07A.31.31,0,0,1,218.36,271.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,273.51a.25.25,0,0,1-.28-.21.27.27,0,0,1,.17-.31.28.28,0,0,1,.22,0,.34.34,0,0,1,.13.18.33.33,0,0,0-.36-.26.32.32,0,0,0-.23.13.3.3,0,0,0-.06.26.35.35,0,0,0,.16.23.39.39,0,0,0,.26,0,.3.3,0,0,0,.22-.25s0,.05,0,.08A.26.26,0,0,1,218.44,273.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.1,265.26a13.65,13.65,0,0,0,.5,3,4.73,4.73,0,0,0,2,.77,4.57,4.57,0,0,0,2.86-.62c.52-.4.84-3.23.69-3.36a7,7,0,0,0-2.94-.92C220.8,264.11,219.09,265,219.1,265.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,268a9,9,0,0,0,1.15.49,3.87,3.87,0,0,0,1.21.23,6.28,6.28,0,0,0,1.23-.17,9.15,9.15,0,0,0,1.19-.37,8.15,8.15,0,0,1-1.18.39,5.8,5.8,0,0,1-1.24.18,3.63,3.63,0,0,1-1.22-.24A7.77,7.77,0,0,1,219.53,268Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.47,267.69a10.54,10.54,0,0,0,1.2.51,3.7,3.7,0,0,0,1.27.23,6.16,6.16,0,0,0,1.28-.17,12.72,12.72,0,0,0,1.24-.38,10.39,10.39,0,0,1-1.23.4,6.38,6.38,0,0,1-1.29.19,4,4,0,0,1-1.28-.25A9,9,0,0,1,219.47,267.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.43,267.39a9,9,0,0,0,1.24.52,3.67,3.67,0,0,0,1.31.25,6.65,6.65,0,0,0,1.33-.18,12,12,0,0,0,1.29-.4,9.71,9.71,0,0,1-1.29.42,6.56,6.56,0,0,1-1.33.19,3.74,3.74,0,0,1-1.32-.26A7.91,7.91,0,0,1,219.43,267.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.47,267.11a10.5,10.5,0,0,0,1.24.53,3.89,3.89,0,0,0,1.31.24,6,6,0,0,0,1.33-.18,12,12,0,0,0,1.29-.4,9.71,9.71,0,0,1-1.29.42,5.94,5.94,0,0,1-1.33.2,4,4,0,0,1-1.32-.26A8,8,0,0,1,219.47,267.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.42,266.79a10.35,10.35,0,0,0,1.29.54,3.91,3.91,0,0,0,1.36.26,7.06,7.06,0,0,0,1.37-.19,12,12,0,0,0,1.33-.41,8.84,8.84,0,0,1-1.32.43,6.47,6.47,0,0,1-1.38.2,4,4,0,0,1-1.37-.26A9.78,9.78,0,0,1,219.42,266.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.35,266.44a12.74,12.74,0,0,0,1.32.56,4.17,4.17,0,0,0,1.39.26,6.23,6.23,0,0,0,1.42-.2,11.36,11.36,0,0,0,1.37-.42,11,11,0,0,1-1.37.45,6.16,6.16,0,0,1-1.42.2,4,4,0,0,1-1.4-.27A9,9,0,0,1,219.35,266.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.29,266.1a11.78,11.78,0,0,0,1.37.59,4.28,4.28,0,0,0,1.45.27,6.6,6.6,0,0,0,1.47-.21,12.18,12.18,0,0,0,1.42-.43,11.21,11.21,0,0,1-1.42.46,7.24,7.24,0,0,1-1.47.21,4.3,4.3,0,0,1-1.46-.28A10.29,10.29,0,0,1,219.29,266.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.22,265.78a10.17,10.17,0,0,0,1.4.6,4.23,4.23,0,0,0,1.49.28,6.47,6.47,0,0,0,1.51-.21,12.92,12.92,0,0,0,1.46-.45,10.79,10.79,0,0,1-1.46.47,6.4,6.4,0,0,1-1.51.22,4.3,4.3,0,0,1-1.5-.29A8.66,8.66,0,0,1,219.22,265.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,265.71a10.77,10.77,0,0,1,1.46-.29,1.8,1.8,0,0,0,1.49-1.5l1-6.22a1.8,1.8,0,0,0-1.1-1.94l-2-.8Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234,265.71a10.77,10.77,0,0,1,1.46-.29,1.8,1.8,0,0,0,1.49-1.5l1-6.22a1.8,1.8,0,0,0-1.1-1.94l-2-.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210.51,265.5a9.66,9.66,0,0,0-1.47-.24,1.78,1.78,0,0,1-1.53-1.45l-1.18-6.18a1.79,1.79,0,0,1,1-2l1.95-.86Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.51,265.5a9.66,9.66,0,0,0-1.47-.24,1.78,1.78,0,0,1-1.53-1.45l-1.18-6.18a1.79,1.79,0,0,1,1-2l1.95-.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M234.09,267.23a137.11,137.11,0,0,0,1.64-20.14s-14.83-2.32-26.94-.14c0,0,.54,15.55,1.56,19.9C210.35,266.85,222.73,267.5,234.09,267.23Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.55,246c0,1.75,0,3.51,0,5.27l.05,5.27.06-.07-6,.44-3,.23-3,.24,3-.18,3-.19,6-.41h.06v-.06l-.08-5.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.62,246.94a.37.37,0,0,0-.24-.12.27.27,0,0,0-.23.09.27.27,0,0,1,.21,0,.28.28,0,0,1,.2.31.27.27,0,0,1-.28.23.27.27,0,0,1-.2-.09.31.31,0,0,1-.06-.23.34.34,0,0,0,.51.35.35.35,0,0,0,.09-.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.64,249.26v0a.24.24,0,0,0-.06-.11.34.34,0,0,0-.24-.13.32.32,0,0,0-.31.18.34.34,0,0,1,.09-.08.26.26,0,0,1,.39.14s0,0,0,0v0a.17.17,0,0,1,0,.1.31.31,0,0,1-.18.21h-.07s0,0,0,0,0,0,0,0h0a.25.25,0,0,1-.14-.08.29.29,0,0,1-.06-.22.32.32,0,0,0,.11.3l0,0,0,0,.07,0a.34.34,0,0,0,.24,0h0l0,0a.34.34,0,0,0,.13-.2A.49.49,0,0,0,222.64,249.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.05,251.42l0,0,0,0Zm-.05.28s0,0,0,0h0S222,251.72,222,251.7Zm.05-.28,0,0,0,0Zm0,0,0,0,0,0Zm.54,0s0,0,0,0h0l0,0a.34.34,0,0,0-.48,0,0,0,0,0,0,0,0s0,0,0,0l0,0,0,0h0a.26.26,0,0,1,.21,0l.09,0,0,0s0,0,0,0a.27.27,0,0,1,.07.22.42.42,0,0,1,0,.1s0,0,0,0l0,0a.24.24,0,0,1-.21.09.29.29,0,0,1-.2-.09h0l0,0v0s0,0,0,0,0,0,0,0v0s0,0,0,0a.3.3,0,0,0,.21.17.35.35,0,0,0,.26,0,.32.32,0,0,0,.11-.12v0s0,0,0,0,0-.05,0-.08A.31.31,0,0,0,222.59,251.43Zm-.56,0,0,0h0Zm0,0,0,0,0,0Zm0,0,0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.59,253.7a.27.27,0,0,0-.17-.11h-.2a.26.26,0,0,0-.14.13l0,0a.26.26,0,0,1,.21,0,.28.28,0,0,1,.2.27v0a.29.29,0,0,1-.29.23.3.3,0,0,1-.19-.1A.22.22,0,0,1,222,254a.31.31,0,0,0,.23.24.36.36,0,0,0,.27,0,.33.33,0,0,0,.15-.23v-.06A.32.32,0,0,0,222.59,253.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,257.44l-.05-.07a.29.29,0,0,0,.07.12h0Zm0-.31v0s0,0,0,0l0-.06A.13.13,0,0,0,220.18,257.13Zm.63.05s0,0,0,0,0,0,0,0a.22.22,0,0,0-.05-.08.37.37,0,0,0-.24-.12.3.3,0,0,0-.28.14l.05,0a.29.29,0,0,1,.22,0,.29.29,0,0,1,.16.13s0,0,0,0v0a.27.27,0,0,1-.11.31l0,0h-.05l0,0h0a0,0,0,0,1,0,0,0,0,0,0,1,0,0h0a.06.06,0,0,1,0,0h0l0,0-.06-.05-.05-.07a.29.29,0,0,0,.07.12l0,0,0,0a.35.35,0,0,0,.12.07.36.36,0,0,0,.27,0l0,0,0,0,0,0a.3.3,0,0,0,.08-.16A.26.26,0,0,0,220.81,257.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,257.39s0,.05,0,.07,0,0,0,0,0,0,0,0A.17.17,0,0,1,218,257.39Zm.6-.16a.25.25,0,0,0-.1-.08l0,0a.11.11,0,0,0-.08,0h-.08l-.08,0h0l0,0a.33.33,0,0,0-.13.13.34.34,0,0,1,.09-.08.29.29,0,0,1,.22,0,.27.27,0,0,1,.19.3v0a.26.26,0,0,1-.27.2.32.32,0,0,1-.2-.1.18.18,0,0,1,0-.1v0h0a0,0,0,0,0,0,0,.32.32,0,0,0,.25.26.35.35,0,0,0,.26,0,.28.28,0,0,0,.15-.22h0v0A.33.33,0,0,0,218.56,257.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.83,257.78a.56.56,0,0,1-.05-.08.18.18,0,0,0,0,.1h0Zm0-.3a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm0,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm0,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm.62,0v0a0,0,0,0,0,0,0l0-.05a.33.33,0,0,0-.24-.12.32.32,0,0,0-.3.16.27.27,0,0,1,.08-.07.26.26,0,0,1,.21,0,.28.28,0,0,1,.15.11,0,0,0,0,1,0,0v0a.23.23,0,0,1,0,.16.24.24,0,0,1-.09.15l0,0,0,0h0a.28.28,0,0,1-.13,0,.1.1,0,0,1-.08,0h0s0,0,0,0h0l0,0,0,0a.56.56,0,0,1-.05-.08.18.18,0,0,0,0,.1v0l0,0a.34.34,0,0,0,.17.11.31.31,0,0,0,.26-.05l.05,0h0a0,0,0,0,1,0,0l0,0a.27.27,0,0,0,.07-.14A.28.28,0,0,0,216.41,257.49Zm-.62,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm0,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm0,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.17,257.57a.25.25,0,0,0-.16-.11h-.17a.29.29,0,0,0-.14.08.29.29,0,0,1,.42.24s0,0,0,0v0a.26.26,0,0,1-.28.23.25.25,0,0,1-.19-.09.22.22,0,0,1,0-.08.31.31,0,0,0,.23.24.36.36,0,0,0,.27,0,.33.33,0,0,0,.15-.24h0v-.05A.34.34,0,0,0,214.17,257.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,257.8v0s0,0,0,0l0,0a.35.35,0,0,0-.25-.1.32.32,0,0,0-.26.13v0l0,0a.33.33,0,0,0,0,.14.35.35,0,0,1,.06-.14s0,0,0,0,0,0,0,0l0,0a.29.29,0,0,1,.22,0,.21.21,0,0,1,.13.07l0,0s0,0,0,0a.28.28,0,0,1,0,.32v0l0,0a.24.24,0,0,1-.17.07.21.21,0,0,1-.15-.08h0v0h0s0,0,0,0a.33.33,0,0,0,.47.08.13.13,0,0,0,.06-.07l0,0s0,0,0,0a.2.2,0,0,0,0-.13A.25.25,0,0,0,212,257.8Zm-.58.31s0,0,0,0a0,0,0,0,1,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,256.38a.22.22,0,0,1,0-.08.24.24,0,0,0,.07.13h0A.18.18,0,0,1,222.07,256.38Zm.59-.29v0a.22.22,0,0,0-.05-.08.33.33,0,0,0-.24-.12.33.33,0,0,0-.31.17.3.3,0,0,1,.08-.08.29.29,0,0,1,.22,0,.29.29,0,0,1,.17.14v0s0,0,0,0a.24.24,0,0,1,0,.12.26.26,0,0,1-.13.19l0,0-.1,0h0l-.08,0h0l0,0a.18.18,0,0,1-.07-.05.22.22,0,0,1,0-.08.24.24,0,0,0,.07.13l0,0,0,0a.24.24,0,0,0,.12.07.36.36,0,0,0,.27,0l0,0s0,0,0,0l0,0a.3.3,0,0,0,.08-.17.33.33,0,0,0,0-.14S222.66,256.1,222.66,256.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48,265.92a109.6,109.6,0,0,0,1.42-17.09s-14.81-1.89-23.34-.12c0,0,.48,13.11,1.35,16.88C211.91,265.59,222.64,266.15,232.48,265.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.57,249.13c.09,2.27.56,13.09,1.34,16.46,0,0,10.32.54,20,.34a111.07,111.07,0,0,0,1.34-16.58S219.05,247.53,210.57,249.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.18,
    y1: 248.51,
    x2: 218.55,
    y2: 248.48,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.15,248.55l-5.44-.06h.84c1.22,0,2.44,0,3.63,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.47,
    y1: 248.95,
    x2: 212.98,
    y2: 248.78,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,249l-16.92-.18.17,0,.19,0,16,.17h0l.28,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.25,
    y1: 249.36,
    x2: 210.65,
    y2: 249.11,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,249.35v0l-22.68-.25h0l.08,0,.12,0,22.36.24h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.25,
    y1: 249.72,
    x2: 210.59,
    y2: 249.47,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,249.69v.05l-22.66-.25v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.24,
    y1: 250.08,
    x2: 210.6,
    y2: 249.83,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.24,250.05v0l-22.64-.25v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.23,
    y1: 250.44,
    x2: 210.62,
    y2: 250.19,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,250.41v.05l-22.61-.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.22,
    y1: 250.8,
    x2: 210.64,
    y2: 250.55,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.22,250.78v0l-22.58-.24v0a0,0,0,0,1,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.21,
    y1: 251.16,
    x2: 210.65,
    y2: 250.92,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,251.14v0l-22.56-.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.2,
    y1: 251.52,
    x2: 210.67,
    y2: 251.28,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.2,251.5v0l-22.53-.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.19,
    y1: 251.88,
    x2: 210.69,
    y2: 251.64,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.19,251.86v0l-22.5-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.18,
    y1: 252.24,
    x2: 210.7,
    y2: 252,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18,252.22v0L210.71,252v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.17,
    y1: 252.6,
    x2: 210.72,
    y2: 252.36,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.17,252.58v0s0,0,0,0l-22.44-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.15,
    y1: 252.96,
    x2: 210.74,
    y2: 252.72,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,252.94v0l-22.41-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.14,
    y1: 253.32,
    x2: 210.76,
    y2: 253.08,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.14,253.3v0l-22.38-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.12,
    y1: 253.68,
    x2: 210.78,
    y2: 253.44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.12,253.66v0l-22.34-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.1,
    y1: 254.04,
    x2: 210.8,
    y2: 253.8,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1,254v0l-22.3-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.08,
    y1: 254.4,
    x2: 210.82,
    y2: 254.16,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,254.38v0l-22.26-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.06,
    y1: 254.76,
    x2: 210.84,
    y2: 254.52,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.07,254.74s0,0,0,0v0l-22.22-.24v0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.04,
    y1: 255.12,
    x2: 210.86,
    y2: 254.89,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,255.1v0l-22.18-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.02,
    y1: 255.48,
    x2: 210.88,
    y2: 255.25,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,255.46v0l-22.14-.23v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233,
    y1: 255.84,
    x2: 210.9,
    y2: 255.61,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,255.82v.05l-22.1-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.98,
    y1: 256.2,
    x2: 210.92,
    y2: 255.97,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,256.18v.05L210.92,256v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.96,
    y1: 256.56,
    x2: 210.94,
    y2: 256.33,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,256.54v0a0,0,0,0,0,0,0l-22-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.93,
    y1: 256.93,
    x2: 210.97,
    y2: 256.69,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,256.9V257l-22-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.9,
    y1: 257.29,
    x2: 210.99,
    y2: 257.05,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,257.26v.05L211,257.07v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.88,
    y1: 257.65,
    x2: 211.02,
    y2: 257.41,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.88,257.62v0s0,0,0,0L211,257.43v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.85,
    y1: 258.01,
    x2: 211.04,
    y2: 257.77,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.85,258v0l-21.8-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.82,
    y1: 258.37,
    x2: 211.07,
    y2: 258.13,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.82,258.34v.05l-21.75-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.79,
    y1: 258.73,
    x2: 211.09,
    y2: 258.49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.79,258.7v.05l-21.7-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.76,
    y1: 259.09,
    x2: 211.12,
    y2: 258.85,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.76,259.06v0a0,0,0,0,1,0,0l-21.63-.23v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.72,
    y1: 259.45,
    x2: 211.15,
    y2: 259.22,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,259.43v0l-21.57-.23v0a0,0,0,0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.69,
    y1: 259.81,
    x2: 211.18,
    y2: 259.58,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.69,259.79v0l-21.51-.23v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.66,
    y1: 260.17,
    x2: 211.21,
    y2: 259.94,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.66,260.15v0L211.21,260v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.62,
    y1: 260.53,
    x2: 211.24,
    y2: 260.3,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.62,260.51v0l-21.38-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.58,
    y1: 260.89,
    x2: 211.27,
    y2: 260.66,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.59,260.87v0l-21.31-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.54,
    y1: 261.25,
    x2: 211.3,
    y2: 261.02,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.55,261.23v0L211.3,261v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.51,
    y1: 261.61,
    x2: 211.33,
    y2: 261.38,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.51,261.59v0l-21.16-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.46,
    y1: 261.97,
    x2: 211.37,
    y2: 261.74,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.47,262v0l-21.09-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.42,
    y1: 262.33,
    x2: 211.41,
    y2: 262.1,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,262.31v0l-21-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.38,
    y1: 262.69,
    x2: 211.45,
    y2: 262.46,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38,262.67v0l-20.92-.22v0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.33,
    y1: 263.05,
    x2: 211.49,
    y2: 262.83,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.34,263v0l-20.84-.22v0a0,0,0,0,1,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.29,
    y1: 263.41,
    x2: 211.53,
    y2: 263.19,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,263.39v0l-20.75-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.24,
    y1: 263.77,
    x2: 211.57,
    y2: 263.55,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.24,263.75v0l-20.66-.22v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.19,
    y1: 264.13,
    x2: 211.62,
    y2: 263.91,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,264.11v0l-20.56-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.14,
    y1: 264.49,
    x2: 211.67,
    y2: 264.27,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14,264.47v0l-20.45-.22s0,0,0,0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.08,
    y1: 264.85,
    x2: 211.73,
    y2: 264.63,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.09,264.83a0,0,0,0,0,0,0v0l-20.35-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.03,
    y1: 265.21,
    x2: 211.79,
    y2: 264.99,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,265.19v0s0,0,0,0L211.8,265v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.97,
    y1: 265.57,
    x2: 211.86,
    y2: 265.35,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,265.55v0s0,0,0,0l-20.09-.21v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.82 265.76 215.83 265.76 231.91 265.93",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.91,265.91v0h0l-.62,0-14.52-.16-.94,0h0l-.81,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.69,259.19a1.89,1.89,0,0,0,.31,1.16,1.47,1.47,0,0,0,.49.43,1.57,1.57,0,0,0,.63.15,1.25,1.25,0,0,0,.65-.16,1.35,1.35,0,0,0,.46-.46,2.06,2.06,0,0,0,.25-1.18,3,3,0,0,1-.48,1,1,1,0,0,1-.87.43,1.22,1.22,0,0,1-.91-.4A2.55,2.55,0,0,1,220.69,259.19Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,258.59c1.12,0,1.08,2.22,0,2.23S227.29,258.61,228.22,258.59Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,258.44c1.12,0,1.07,2.22,0,2.24S214.65,258.46,215.59,258.44Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.23,258.61a71.84,71.84,0,0,1-.56-8.67,34.5,34.5,0,0,1,8.93-.74c-1.45.13-2.9.26-4.34.45a40.05,40.05,0,0,0-4.27.73l.18-.24c0,2.82.08,5.64.06,8.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,271.42a2.87,2.87,0,0,1-.66,1.39,1,1,0,0,1-.35.29L216,273c-.34-.13-.67-.27-1-.42a3.39,3.39,0,0,1-.24-2.17,3.12,3.12,0,0,1,.48-1.17,1.39,1.39,0,0,1,.4-.43.86.86,0,0,1,.84-.14C217.14,268.94,217.51,270.18,217.26,271.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.74,270.4c-.21,1.05.1,2.09.69,2.33h0c.59.21,1.22-.44,1.42-1.47a2.39,2.39,0,0,0-.5-2.22l-.2-.11C215.59,268.7,214.94,269.36,214.74,270.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,270.53a2.37,2.37,0,0,0,.5,2.21c.59.21,1.22-.44,1.42-1.47a2.39,2.39,0,0,0-.5-2.22C215.79,268.85,215.16,269.5,215,270.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.49,270.05l.65.2a1,1,0,0,1,.11.68c-.05.34-.22.57-.28.55l-.66-.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.49,270.05c-.12,0-.25.22-.3.56s0,.64.12.67.25-.21.3-.55S215.6,270.09,215.49,270.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,272.81a.76.76,0,0,1,0,.15,2,2,0,0,1,0,.24,1.76,1.76,0,0,1-.3-.1L216,273c-.34-.13-.67-.27-1-.42a15.8,15.8,0,0,1-1.63-.86,7.43,7.43,0,0,1,.59-1,4.9,4.9,0,0,1,1.28-1.43.51.51,0,0,1,.15-.07.57.57,0,0,1,.18,0,.33.33,0,0,1,.22,0,.56.56,0,0,1,.29.16,5.76,5.76,0,0,1,.59,2.71A4,4,0,0,1,216.6,272.81Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.29,272.58c-.32.15-.65.28-1,.41l-.31.11a1.29,1.29,0,0,1-.37-.3,3,3,0,0,1-.64-1.38c-.25-1.24.12-2.48.83-2.76a.84.84,0,0,1,.85.16,1.29,1.29,0,0,1,.39.41,3.12,3.12,0,0,1,.48,1.17A3.36,3.36,0,0,1,229.29,272.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51,270.4c.21,1.05-.1,2.09-.69,2.33h0c-.58.21-1.21-.44-1.41-1.47a2.39,2.39,0,0,1,.5-2.22l.19-.11C228.66,268.7,229.31,269.36,229.51,270.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.29,270.53a2.34,2.34,0,0,1-.51,2.21c-.58.21-1.21-.44-1.41-1.47a2.39,2.39,0,0,1,.5-2.22C228.46,268.85,229.09,269.5,229.29,270.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.76,270.05l-.65.2a1,1,0,0,0-.11.68c.05.34.22.57.28.55l.66-.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.76,270.05c.12,0,.25.22.3.56s0,.64-.12.67-.25-.21-.3-.55S228.65,270.09,228.76,270.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.93,271.71a14.27,14.27,0,0,1-1.64.87c-.32.15-.65.28-1,.41l-.31.11a1.92,1.92,0,0,1-.31.11c0-.09,0-.17,0-.25a.78.78,0,0,1,0-.16,6.75,6.75,0,0,1,0-.79h0a5.73,5.73,0,0,1,.6-2.69.56.56,0,0,1,.29-.16.37.37,0,0,1,.23,0l.16,0a.56.56,0,0,1,.16.07,4.77,4.77,0,0,1,1.28,1.43A7.43,7.43,0,0,1,230.93,271.71Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.13,
    cy: 372.68,
    r: 17.25,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.07,378.27h0",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,384.93a.2.2,0,0,1,0,.07s0,.07,0,.11h0c0,.21-.06.47-.09.77s-.09.84-.14,1.33-.09.86-.14,1.32l0,.25-.31.11a1.92,1.92,0,0,1-.31.11,17.31,17.31,0,0,1-8.44.68l-.12,0a15.76,15.76,0,0,1-2.58-.67,1.76,1.76,0,0,1-.3-.1l-.3-.11,0-.26c0-.46-.1-.9-.14-1.31s-.09-.94-.14-1.32-.06-.58-.09-.79h0s0-.07,0-.1a.2.2,0,0,1,0-.07.49.49,0,0,1,0-.12.47.47,0,0,1,.06-.21.57.57,0,0,1,.33-.3,21.44,21.44,0,0,1,3.49-.86l.4-.06h0l.49-.06h0l.6-.06h.1c.39,0,.74-.05,1.06-.05h0c.33,0,.71,0,1.11.05h.09l.66.07h0l.53.07h0l.23,0a20.93,20.93,0,0,1,3.53.87.54.54,0,0,1,.34.32.37.37,0,0,1,.06.21A.34.34,0,0,1,228.74,384.93Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25,389.69l-.12,0-.07-2.56-.05-1.76,0-1.76.09,1.76.08,1.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.43,384.87a.3.3,0,0,1-.19.1.27.27,0,0,1-.28-.22.26.26,0,0,1,.18-.3.26.26,0,0,1,.21,0,.25.25,0,0,0-.23-.09.39.39,0,0,0-.23.13.37.37,0,0,0-.06.27.33.33,0,0,0,.16.22.32.32,0,0,0,.48-.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,387.08a.27.27,0,0,1-.28-.22.27.27,0,0,1,.18-.31.31.31,0,0,1,.21,0,.29.29,0,0,1,.13.19.33.33,0,0,0-.36-.27.39.39,0,0,0-.23.13.4.4,0,0,0-.06.27.36.36,0,0,0,.16.22.39.39,0,0,0,.26,0,.31.31,0,0,0,.23-.24l0,.07A.31.31,0,0,1,218.36,387.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,389.31a.25.25,0,0,1-.28-.21.27.27,0,0,1,.17-.31.28.28,0,0,1,.22,0,.34.34,0,0,1,.13.18.33.33,0,0,0-.36-.26.32.32,0,0,0-.23.13.3.3,0,0,0-.06.26.35.35,0,0,0,.16.23.39.39,0,0,0,.26,0,.3.3,0,0,0,.22-.25s0,.05,0,.08A.26.26,0,0,1,218.44,389.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.1,381.06a13.55,13.55,0,0,0,.5,3,4.72,4.72,0,0,0,2,.78,4.57,4.57,0,0,0,2.86-.63c.52-.4.84-3.23.69-3.36a7.16,7.16,0,0,0-2.94-.91C220.8,379.92,219.09,380.79,219.1,381.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,383.82a9,9,0,0,0,1.15.48,3.37,3.37,0,0,0,1.21.23,5.61,5.61,0,0,0,1.23-.17,11,11,0,0,0,1.19-.36,9.55,9.55,0,0,1-1.18.38,5.23,5.23,0,0,1-1.24.18,3.4,3.4,0,0,1-1.22-.24A6.8,6.8,0,0,1,219.53,383.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.47,383.49a9,9,0,0,0,1.2.51,3.71,3.71,0,0,0,1.27.24,6.17,6.17,0,0,0,1.28-.18,10.46,10.46,0,0,0,1.24-.38,8.83,8.83,0,0,1-1.23.4,6.38,6.38,0,0,1-1.29.19,3.74,3.74,0,0,1-1.28-.25A7.86,7.86,0,0,1,219.47,383.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.43,383.19a10.5,10.5,0,0,0,1.24.53A3.89,3.89,0,0,0,222,384a6,6,0,0,0,1.33-.18,12,12,0,0,0,1.29-.4,9.71,9.71,0,0,1-1.29.42,5.94,5.94,0,0,1-1.33.2,4,4,0,0,1-1.32-.26A8,8,0,0,1,219.43,383.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.47,382.91a9.06,9.06,0,0,0,1.24.53,3.9,3.9,0,0,0,1.31.25,6.66,6.66,0,0,0,1.33-.19,10,10,0,0,0,1.29-.39,8.41,8.41,0,0,1-1.29.41,5.94,5.94,0,0,1-1.33.2,4,4,0,0,1-1.32-.26A8,8,0,0,1,219.47,382.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.42,382.59a10.41,10.41,0,0,0,1.29.55,3.9,3.9,0,0,0,1.36.25,5.8,5.8,0,0,0,1.37-.19,10.22,10.22,0,0,0,1.33-.41,8.84,8.84,0,0,1-1.32.43,6.49,6.49,0,0,1-1.38.21,4.28,4.28,0,0,1-1.37-.27A7.69,7.69,0,0,1,219.42,382.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.35,382.24a9.5,9.5,0,0,0,1.32.56,3.93,3.93,0,0,0,1.39.26,6.22,6.22,0,0,0,1.42-.19,13.5,13.5,0,0,0,1.37-.42,10.93,10.93,0,0,1-1.37.44,6.76,6.76,0,0,1-1.42.21,4.2,4.2,0,0,1-1.4-.28A8,8,0,0,1,219.35,382.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.29,381.91a11.71,11.71,0,0,0,1.37.58,4.28,4.28,0,0,0,1.45.27,6.59,6.59,0,0,0,1.47-.2,12.23,12.23,0,0,0,1.42-.44,9.81,9.81,0,0,1-1.42.46,6.07,6.07,0,0,1-1.47.21,4.07,4.07,0,0,1-1.46-.28A10.23,10.23,0,0,1,219.29,381.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.22,381.59a11.56,11.56,0,0,0,1.4.6,4.46,4.46,0,0,0,1.49.27,7,7,0,0,0,1.51-.2c.49-.13,1-.27,1.46-.45a12.41,12.41,0,0,1-1.46.47,7,7,0,0,1-1.51.22,4.81,4.81,0,0,1-1.5-.29A9.64,9.64,0,0,1,219.22,381.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,381.51a10.77,10.77,0,0,1,1.46-.29,1.79,1.79,0,0,0,1.49-1.49l1-6.22a1.81,1.81,0,0,0-1.1-1.95l-2-.79Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234,381.51a10.77,10.77,0,0,1,1.46-.29,1.79,1.79,0,0,0,1.49-1.49l1-6.22a1.81,1.81,0,0,0-1.1-1.95l-2-.79Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210.51,381.3a10.37,10.37,0,0,0-1.47-.23,1.79,1.79,0,0,1-1.53-1.45l-1.18-6.18a1.79,1.79,0,0,1,1-2l1.95-.87Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.51,381.3a10.37,10.37,0,0,0-1.47-.23,1.79,1.79,0,0,1-1.53-1.45l-1.18-6.18a1.79,1.79,0,0,1,1-2l1.95-.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M234.09,383a137.17,137.17,0,0,0,1.64-20.15s-14.83-2.31-26.94-.14c0,0,.54,15.55,1.56,19.91C210.35,382.66,222.73,383.31,234.09,383Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.55,361.83c0,1.76,0,3.51,0,5.27l.05,5.27.06-.06-6,.43-3,.23-3,.25,3-.18,3-.19,6-.42h.06v-.06l-.08-5.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.62,362.74a.37.37,0,0,0-.24-.12.27.27,0,0,0-.23.09.27.27,0,0,1,.21,0,.28.28,0,0,1,.2.31.27.27,0,0,1-.28.23.27.27,0,0,1-.2-.09.31.31,0,0,1-.06-.23.34.34,0,0,0,.51.35.35.35,0,0,0,.09-.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.64,365.06v0a.24.24,0,0,0-.06-.11.34.34,0,0,0-.24-.13.32.32,0,0,0-.31.18.34.34,0,0,1,.09-.08.26.26,0,0,1,.39.14s0,0,0,0v0a.17.17,0,0,1,0,.1.31.31,0,0,1-.18.21h-.07s0,0,0,0,0,0,0,0h0a.25.25,0,0,1-.14-.08.29.29,0,0,1-.06-.22.32.32,0,0,0,.11.3l0,0,0,0,.07,0a.34.34,0,0,0,.24,0h0l0,0a.34.34,0,0,0,.13-.2A.49.49,0,0,0,222.64,365.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.05,367.22l0,0,0,0Zm-.05.28s0,0,0,0h0Zm.05-.28,0,0,0,0Zm0,0,0,0,0,0Zm.54,0s0,0,0,0h0l0,0a.34.34,0,0,0-.48,0v0s0,0,0,0,0,0,0,0l0,0h0a.26.26,0,0,1,.21,0l.09,0,0,0,0,0a.27.27,0,0,1,.07.22.42.42,0,0,1,0,.1v0l0,0a.24.24,0,0,1-.21.09.29.29,0,0,1-.2-.09h0l0,0v0l0,0s0,0,0,0v0a.3.3,0,0,0,.21.17.35.35,0,0,0,.26,0,.32.32,0,0,0,.11-.12v0s0,0,0,0,0-.05,0-.08A.31.31,0,0,0,222.59,367.23Zm-.56,0,0,0h0Zm0,0,0,0,0,0Zm0,0,0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.59,369.5a.27.27,0,0,0-.17-.11h-.2a.26.26,0,0,0-.14.13l0,0a.26.26,0,0,1,.21,0,.28.28,0,0,1,.2.27v0a.29.29,0,0,1-.29.23.3.3,0,0,1-.19-.1.22.22,0,0,1-.05-.08.31.31,0,0,0,.23.24.36.36,0,0,0,.27,0,.33.33,0,0,0,.15-.23v-.06A.32.32,0,0,0,222.59,369.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,373.24l-.05-.07a.29.29,0,0,0,.07.12h0Zm0-.31v0s0,0,0,0l0-.06A.13.13,0,0,0,220.18,372.93Zm.63.05s0,0,0,0v0a.22.22,0,0,0-.05-.08.37.37,0,0,0-.24-.12.3.3,0,0,0-.28.14l.05,0a.29.29,0,0,1,.22,0,.29.29,0,0,1,.16.13v0s0,0,0,0a.27.27,0,0,1-.11.31l0,0h-.05l0,0h-.06a.06.06,0,0,1,0,0h0l0,0-.06-.05-.05-.07a.29.29,0,0,0,.07.12l0,0,0,0a.35.35,0,0,0,.12.07.36.36,0,0,0,.27,0,0,0,0,0,0,0,0l0,0,0,0a.3.3,0,0,0,.08-.16A.26.26,0,0,0,220.81,373Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,373.19s0,.05,0,.07v0s0,0,0,0A.17.17,0,0,1,218,373.19Zm.6-.16a.25.25,0,0,0-.1-.08l0,0a.11.11,0,0,0-.08,0h-.08l-.08,0h0l0,0a.33.33,0,0,0-.13.13.34.34,0,0,1,.09-.08.29.29,0,0,1,.22,0,.27.27,0,0,1,.19.3v0a.26.26,0,0,1-.27.2.32.32,0,0,1-.2-.1.18.18,0,0,1,0-.1v0h0a0,0,0,0,0,0,0,.32.32,0,0,0,.25.26.35.35,0,0,0,.26,0,.28.28,0,0,0,.15-.22h0v0A.33.33,0,0,0,218.56,373Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.83,373.58a.56.56,0,0,1-.05-.08.18.18,0,0,0,0,.1h0Zm0-.3a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm0,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm0,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm.62,0a0,0,0,0,0,0,0v0l0-.05a.33.33,0,0,0-.24-.12.32.32,0,0,0-.3.16.27.27,0,0,1,.08-.07.26.26,0,0,1,.21,0,.28.28,0,0,1,.15.11v0a0,0,0,0,1,0,0,.23.23,0,0,1,0,.16.24.24,0,0,1-.09.15l0,0,0,0h0a.28.28,0,0,1-.13,0,.1.1,0,0,1-.08,0h0s0,0,0,0h0l0,0,0,0a.56.56,0,0,1-.05-.08.18.18,0,0,0,0,.1v0l0,0a.34.34,0,0,0,.17.11.31.31,0,0,0,.26-.05.12.12,0,0,0,.05-.05h0v0l0,0a.27.27,0,0,0,.07-.14A.28.28,0,0,0,216.41,373.29Zm-.62,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm0,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Zm0,0a.19.19,0,0,0,0,.08.11.11,0,0,1,0-.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.17,373.37a.25.25,0,0,0-.16-.11h-.17a.29.29,0,0,0-.14.08.29.29,0,0,1,.42.24v0a.26.26,0,0,1-.28.23.25.25,0,0,1-.19-.09.22.22,0,0,1,0-.08.31.31,0,0,0,.23.24.36.36,0,0,0,.27,0,.33.33,0,0,0,.15-.24h0v-.05A.34.34,0,0,0,214.17,373.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,373.6s0,0,0,0,0,0,0,0l0,0a.35.35,0,0,0-.25-.1.32.32,0,0,0-.26.13v0l0,0a.33.33,0,0,0,0,.14.35.35,0,0,1,.06-.14l0,0s0,0,0,0l0,0a.29.29,0,0,1,.22,0,.21.21,0,0,1,.13.07l0,0s0,0,0,0a.28.28,0,0,1,0,.32v0l0,0a.24.24,0,0,1-.17.07.21.21,0,0,1-.15-.08h0v0h0s0,0,0,0a.33.33,0,0,0,.47.08A.13.13,0,0,0,212,374l0,0s0,0,0,0a.2.2,0,0,0,0-.13A.25.25,0,0,0,212,373.6Zm-.58.31s0,0,0,0a0,0,0,0,1,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,372.18a.22.22,0,0,1,0-.08.24.24,0,0,0,.07.13h0A.18.18,0,0,1,222.07,372.18Zm.59-.29v0a.22.22,0,0,0-.05-.08.33.33,0,0,0-.24-.12.33.33,0,0,0-.31.17l.08-.08a.29.29,0,0,1,.22,0,.29.29,0,0,1,.17.14v.05a.24.24,0,0,1,0,.12.26.26,0,0,1-.13.19l0,0-.1,0h0l-.08,0h0l0,0a.18.18,0,0,1-.07-.05.22.22,0,0,1,0-.08.24.24,0,0,0,.07.13l0,0,0,0a.24.24,0,0,0,.12.07.36.36,0,0,0,.27,0,0,0,0,0,0,0,0l0,0,0,0a.3.3,0,0,0,.08-.17.33.33,0,0,0,0-.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48,381.72a109.6,109.6,0,0,0,1.42-17.09s-14.81-1.89-23.34-.12c0,0,.48,13.11,1.35,16.88C211.91,381.39,222.64,382,232.48,381.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.57,364.93c.09,2.27.56,13.09,1.34,16.46,0,0,10.32.55,20,.35a111.45,111.45,0,0,0,1.34-16.59S219.05,363.34,210.57,364.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.18,
    y1: 364.32,
    x2: 218.55,
    y2: 364.28,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.15,364.35l-5.44-.06h.84c1.22,0,2.44,0,3.63,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.47,
    y1: 364.76,
    x2: 212.98,
    y2: 364.58,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,364.78l-16.92-.18.17,0,.19,0,16,.17h0l.28,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.25,
    y1: 365.16,
    x2: 210.65,
    y2: 364.92,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,365.15v0l-22.68-.24h.08l.12,0,22.36.24h.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.25,
    y1: 365.52,
    x2: 210.59,
    y2: 365.28,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,365.5v0l-22.66-.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.24,
    y1: 365.88,
    x2: 210.6,
    y2: 365.64,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.24,365.86v0l-22.64-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.23,
    y1: 366.24,
    x2: 210.62,
    y2: 366,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,366.22v0L210.62,366v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.22,
    y1: 366.6,
    x2: 210.64,
    y2: 366.36,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.22,366.58v0l-22.58-.24v0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.21,
    y1: 366.96,
    x2: 210.65,
    y2: 366.72,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,366.94v0l-22.56-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.2,
    y1: 367.32,
    x2: 210.67,
    y2: 367.08,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.2,367.3v0l-22.53-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.19,
    y1: 367.68,
    x2: 210.69,
    y2: 367.44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.19,367.66v0l-22.5-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.18,
    y1: 368.04,
    x2: 210.7,
    y2: 367.8,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18,368v0l-22.47-.24s0,0,0,0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.17,
    y1: 368.4,
    x2: 210.72,
    y2: 368.16,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.17,368.38v0a0,0,0,0,1,0,0l-22.44-.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.15,
    y1: 368.76,
    x2: 210.74,
    y2: 368.52,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,368.74v.05l-22.41-.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.14,
    y1: 369.13,
    x2: 210.76,
    y2: 368.88,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.14,369.1v0l-22.38-.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.12,
    y1: 369.49,
    x2: 210.78,
    y2: 369.25,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.12,369.46v.05l-22.34-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.1,
    y1: 369.85,
    x2: 210.8,
    y2: 369.61,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1,369.82v.05l-22.3-.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.08,
    y1: 370.21,
    x2: 210.82,
    y2: 369.97,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,370.18v.05L210.82,370v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.06,
    y1: 370.57,
    x2: 210.84,
    y2: 370.33,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.07,370.55v0l-22.22-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.04,
    y1: 370.93,
    x2: 210.86,
    y2: 370.69,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,370.91s0,0,0,0v0l-22.18-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.02,
    y1: 371.29,
    x2: 210.88,
    y2: 371.05,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,371.27v0l-22.14-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233,
    y1: 371.65,
    x2: 210.9,
    y2: 371.41,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,371.63v0l-22.1-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.98,
    y1: 372.01,
    x2: 210.92,
    y2: 371.77,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,372v0l-22.06-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.96,
    y1: 372.37,
    x2: 210.94,
    y2: 372.13,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,372.35v0s0,0,0,0l-22-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.93,
    y1: 372.73,
    x2: 210.97,
    y2: 372.49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,372.71v0l-22-.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.9,
    y1: 373.09,
    x2: 210.99,
    y2: 372.85,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,373.07v0L211,372.88v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.88,
    y1: 373.45,
    x2: 211.02,
    y2: 373.21,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.88,373.43v0s0,0,0,0L211,373.24v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.85,
    y1: 373.81,
    x2: 211.04,
    y2: 373.57,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.85,373.79v0s0,0,0,0L211,373.6v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.82,
    y1: 374.17,
    x2: 211.07,
    y2: 373.94,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.82,374.15v0L211.07,374v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.79,
    y1: 374.53,
    x2: 211.09,
    y2: 374.3,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.79,374.51v0l-21.7-.23v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.76,
    y1: 374.89,
    x2: 211.12,
    y2: 374.66,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.76,374.87v0l-21.63-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.72,
    y1: 375.25,
    x2: 211.15,
    y2: 375.02,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,375.23v0L211.15,375v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.69,
    y1: 375.61,
    x2: 211.18,
    y2: 375.38,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.69,375.59v0l-21.51-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.66,
    y1: 375.97,
    x2: 211.21,
    y2: 375.74,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.66,376v0l-21.44-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.62,
    y1: 376.33,
    x2: 211.24,
    y2: 376.1,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.62,376.31v0l-21.38-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.58,
    y1: 376.69,
    x2: 211.27,
    y2: 376.46,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.59,376.67v0l-21.31-.23v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.54,
    y1: 377.05,
    x2: 211.3,
    y2: 376.82,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.55,377s0,0,0,0v0l-21.24-.22v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.51,
    y1: 377.41,
    x2: 211.33,
    y2: 377.18,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.51,377.39v0l-21.16-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.46,
    y1: 377.77,
    x2: 211.37,
    y2: 377.55,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.47,377.75s0,0,0,0v0l-21.09-.23v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.42,
    y1: 378.13,
    x2: 211.41,
    y2: 377.91,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,378.11v0l-21-.22v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.38,
    y1: 378.49,
    x2: 211.45,
    y2: 378.27,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38,378.47v0s0,0,0,0l-20.92-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.33,
    y1: 378.85,
    x2: 211.49,
    y2: 378.63,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.34,378.83v0l-20.84-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.29,
    y1: 379.21,
    x2: 211.53,
    y2: 378.99,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,379.19v.05L211.53,379v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.24,
    y1: 379.57,
    x2: 211.57,
    y2: 379.35,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.24,379.55v0l-20.66-.22s0,0,0,0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.19,
    y1: 379.93,
    x2: 211.62,
    y2: 379.71,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,379.91v0l-20.56-.23s0,0,0,0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.14,
    y1: 380.29,
    x2: 211.67,
    y2: 380.07,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14,380.27v0l-20.45-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.08,
    y1: 380.65,
    x2: 211.73,
    y2: 380.44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.09,380.63v.05l-20.35-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.03,
    y1: 381.01,
    x2: 211.79,
    y2: 380.8,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,381v0s0,0,0,0l-20.22-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.97,
    y1: 381.37,
    x2: 211.86,
    y2: 381.16,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,381.35v0a0,0,0,0,1,0,0l-20.09-.22v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.82 381.56 215.83 381.56 231.91 381.73",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.91,381.71v0h-.62l-14.52-.16-.94,0h0l-.81,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.69,375a1.87,1.87,0,0,0,.31,1.16,1.28,1.28,0,0,0,.49.43,1.57,1.57,0,0,0,.63.15,1.24,1.24,0,0,0,.65-.15,1.38,1.38,0,0,0,.46-.47,2,2,0,0,0,.25-1.17,3.19,3.19,0,0,1-.48,1,1.06,1.06,0,0,1-.87.43,1.23,1.23,0,0,1-.91-.41A2.48,2.48,0,0,1,220.69,375Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,374.39c1.12,0,1.08,2.22,0,2.24S227.29,374.41,228.22,374.39Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,374.24c1.12,0,1.07,2.22,0,2.24S214.65,374.26,215.59,374.24Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.23,374.41a71.71,71.71,0,0,1-.56-8.67,34.5,34.5,0,0,1,8.93-.74c-1.45.13-2.9.27-4.34.45a42.76,42.76,0,0,0-4.27.74l.18-.25c0,2.83.08,5.65.06,8.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,387.22a2.87,2.87,0,0,1-.66,1.39,1,1,0,0,1-.35.29l-.3-.11c-.34-.13-.67-.27-1-.42a3.39,3.39,0,0,1-.24-2.17,3.12,3.12,0,0,1,.48-1.17,1.39,1.39,0,0,1,.4-.43.86.86,0,0,1,.84-.14C217.14,384.74,217.51,386,217.26,387.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.74,386.21c-.21,1.05.1,2.09.69,2.33h0c.59.2,1.22-.45,1.42-1.48a2.37,2.37,0,0,0-.5-2.21.56.56,0,0,0-.2-.11C215.59,384.51,214.94,385.16,214.74,386.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,386.33a2.39,2.39,0,0,0,.5,2.22c.59.2,1.22-.45,1.42-1.48a2.37,2.37,0,0,0-.5-2.21C215.79,384.65,215.16,385.3,215,386.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.49,385.86l.65.19a1,1,0,0,1,.11.68c-.05.34-.22.57-.28.55l-.66-.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.49,385.86c-.12,0-.25.21-.3.55s0,.64.12.68.25-.22.3-.56S215.6,385.89,215.49,385.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,388.61a.76.76,0,0,1,0,.15,2,2,0,0,1,0,.24,1.76,1.76,0,0,1-.3-.1l-.3-.11c-.34-.13-.67-.27-1-.42a15.8,15.8,0,0,1-1.63-.86,7.43,7.43,0,0,1,.59-1.05,4.9,4.9,0,0,1,1.28-1.43.51.51,0,0,1,.15-.07l.18,0a.33.33,0,0,1,.22,0,.56.56,0,0,1,.29.16,5.76,5.76,0,0,1,.59,2.71A4,4,0,0,1,216.6,388.61Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.29,388.38c-.32.15-.65.28-1,.41l-.31.11a1.29,1.29,0,0,1-.37-.3,3,3,0,0,1-.64-1.38c-.25-1.24.12-2.48.83-2.76a.84.84,0,0,1,.85.16,1.29,1.29,0,0,1,.39.41,3.12,3.12,0,0,1,.48,1.17A3.36,3.36,0,0,1,229.29,388.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51,386.21c.21,1.05-.1,2.09-.69,2.33h0c-.58.2-1.21-.45-1.41-1.48a2.37,2.37,0,0,1,.5-2.21.62.62,0,0,1,.19-.11C228.66,384.51,229.31,385.16,229.51,386.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.29,386.33a2.36,2.36,0,0,1-.51,2.22c-.58.2-1.21-.45-1.41-1.48a2.37,2.37,0,0,1,.5-2.21C228.46,384.65,229.09,385.3,229.29,386.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.76,385.86l-.65.19a1,1,0,0,0-.11.68c.05.34.22.57.28.55l.66-.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.76,385.86c.12,0,.25.21.3.55s0,.64-.12.68-.25-.22-.3-.56S228.65,385.89,228.76,385.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.93,387.51a14.27,14.27,0,0,1-1.64.87c-.32.15-.65.28-1,.41l-.31.11a1.92,1.92,0,0,1-.31.11c0-.09,0-.17,0-.25a.78.78,0,0,1,0-.16,6.75,6.75,0,0,1,0-.79h0a5.73,5.73,0,0,1,.6-2.69.56.56,0,0,1,.29-.16.37.37,0,0,1,.23,0l.16,0a.56.56,0,0,1,.16.07,4.77,4.77,0,0,1,1.28,1.43A7.43,7.43,0,0,1,230.93,387.51Z",
    style: {
      fill: "#079DCA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.78,
    cy: 165.81,
    r: 17.25,
    transform: "translate(-83.38 233.4) rotate(-80.66)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.78,
    cy: 317.92,
    r: 17.25,
    transform: "translate(-234.76 286.49) rotate(-67.8)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,172.18a17.19,17.19,0,0,1-7.95,8.73,16.91,16.91,0,0,1-5.26,1.76l-.29,0a16.8,16.8,0,0,1-2.47.18c-.35,0-.7,0-1,0l-.58-.05a17,17,0,0,1-6.38-1.89,17.25,17.25,0,0,1-9.11-13.09c1-2.09,3.65-1.8,4.62-4.12.06-.16.13-.35.21-.59A43.82,43.82,0,0,1,86,156.31l.05-.09a9.71,9.71,0,0,1,4.38-4.72,8.73,8.73,0,0,1,3.53-.69h0a11.4,11.4,0,0,1,1.35.08,12.29,12.29,0,0,1,2.33.49c.79.08,4.17-.43,6.54,2.59a12.11,12.11,0,0,1,1.67,3.7h0a62.77,62.77,0,0,1,1.52,6.8v0c.21,1.1.37,2,.5,2.65h0c0,.17.07.32.1.44.52,1.93,3.07,2.14,3.74,4.37A1.94,1.94,0,0,1,111.74,172.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.17,171a4.69,4.69,0,0,1-.2.6,3,3,0,0,0-.37-.76,8.68,8.68,0,0,0-1.85-1.83l-1-.84a2.75,2.75,0,0,1-.86-1,3.07,3.07,0,0,0,.94.89l1.1.75a8.71,8.71,0,0,1,2,1.81A3.11,3.11,0,0,1,112.17,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,156.22a22.21,22.21,0,0,0-.79,2.25l-.75,2.28a18.63,18.63,0,0,1-.91,2.23c0,.05,0,.09-.07.14a4.62,4.62,0,0,1-.58.93,1.69,1.69,0,0,1-.51.45l-.54.29a22.24,22.24,0,0,0-2.14,1,4.06,4.06,0,0,0-1.16,1q0-.32,0-.63a5.53,5.53,0,0,1,1-.74,22.89,22.89,0,0,1,2.16-1.08c.17-.09.35-.17.51-.27a.7.7,0,0,0,.21-.14.62.62,0,0,0,.18-.18,5,5,0,0,0,.61-1c.36-.69.65-1.43,1-2.16a40.64,40.64,0,0,1,1.85-4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,180.91a16.91,16.91,0,0,1-5.26,1.76l-.29,0a16.8,16.8,0,0,1-2.47.18c-.35,0-.7,0-1,0l-.58-.05a17,17,0,0,1-6.38-1.89,27.68,27.68,0,0,1,1.88-3.06v0l.23-.31h0a10.14,10.14,0,0,1,3.36-3c2.27-1.09,4.53-.46,6.58,1.07a6.39,6.39,0,0,1,.63.74C101.19,177.26,102.42,178.94,103.79,180.91Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,180.42a.29.29,0,0,0-.26.32.3.3,0,0,0,.59-.06A.3.3,0,0,0,88.23,180.42Zm3.92-.42a.31.31,0,0,0-.26.33.3.3,0,0,0,.33.26.3.3,0,0,0,.26-.32A.3.3,0,0,0,92.15,180Zm3.92-.41a.3.3,0,0,0,.06.59.3.3,0,1,0-.06-.59Zm3.92-.41a.29.29,0,0,0,.06.58.28.28,0,0,0,.26-.32A.29.29,0,0,0,100,179.18Zm-5.59,3.38a.3.3,0,0,0-.25.25l.58.05v0A.3.3,0,0,0,94.4,182.56Zm3.92-.41a.3.3,0,0,0-.26.32.3.3,0,0,0,.18.24l.29,0a.29.29,0,0,0,.12-.26A.3.3,0,0,0,98.32,182.15Zm-2.82-8a.29.29,0,0,0,.06.58.29.29,0,1,0-.06-.58Zm-5.59,3.38h0l-.23.31v0a.29.29,0,0,0,.32.24.29.29,0,0,0,.27-.32A.31.31,0,0,0,89.91,177.52Zm4-.41h0a.29.29,0,0,0-.26.32.29.29,0,0,0,.58,0v0A.29.29,0,0,0,93.88,177.11Zm3.87-.41a.29.29,0,0,0-.26.32.29.29,0,1,0,.58-.06A.28.28,0,0,0,97.75,176.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.56,176.68c.24.6,3.82,4.14,6.62,3.56.91-.19.1-5.21.1-5.21l0-.38.35-5.38-6.72-3-1-.38s0,1.48,0,3.32v.56c0,.28,0,.56,0,.84s0,.42,0,.64l0,.67A33.94,33.94,0,0,0,93.56,176.68Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,169.25a10.83,10.83,0,0,0,7.31,5.4l.35-5.38-6.72-3-1-.38S93,167.41,93,169.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.26,161.19c1,9.4-4.52,11.06-6.54,11.28-1.85.19-8.14.62-10.11-8.63s2.09-12.69,6.28-13.36S106.26,151.78,107.26,161.19Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.79,159.17c-.22,0-.43,0-.65-.07a1.13,1.13,0,0,1-.65-.19.33.33,0,0,1,0-.41.81.81,0,0,1,.79-.28,1.19,1.19,0,0,1,.81.34A.37.37,0,0,1,104.79,159.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6,159.89a5,5,0,0,0,.62-.2,1.06,1.06,0,0,0,.59-.33.32.32,0,0,0,0-.4.84.84,0,0,0-.84-.11,1.18,1.18,0,0,0-.72.51A.36.36,0,0,0,98.6,159.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.1,162.13s0,0,0,.07c.11.63.12,1.38-.43,1.67,0,0,0,0,0,0C100.33,163.71,100.3,162.72,100.1,162.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.45,161.54c-1,.06-.85,2.13.11,2.08S100.31,161.49,99.45,161.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.05,161.69c-.17.13-.33.35-.55.4s-.46-.16-.64-.35c0,0,0,0,0,0,0,.4.22.79.65.81s.64-.36.7-.77C99.19,161.74,99.12,161.63,99.05,161.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8,161.64s0,0,0,.06c0,.64.18,1.37.78,1.53,0,0,0,0,0,0C103.91,163.23,103.73,162.26,103.8,161.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32,160.92c1-.16,1.28,1.9.33,2.06S103.46,161.06,104.32,160.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.76,161c.18.09.37.27.56.25s.37-.25.49-.48c0,0,0,0,0,0,.06.4,0,.82-.39,1s-.63-.2-.77-.58C104.65,161.09,104.69,161,104.76,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.79,167.25c.16.15.32.35.56.36a1.67,1.67,0,0,0,.68-.2s0,0,0,0a.87.87,0,0,1-.8.38.67.67,0,0,1-.53-.54A0,0,0,0,1,100.79,167.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,164.66a13.94,13.94,0,0,1,.27,1.4s-.1.07-.25.1h0a2.16,2.16,0,0,1-2.16-.59s0-.09.06-.07a3.22,3.22,0,0,0,2,.36c0-.13-.45-1.6-.38-1.61a4,4,0,0,1,1,.12c-.42-2-1.16-3.87-1.55-5.85,0-.07.09-.1.11,0a32.35,32.35,0,0,1,1.95,6.23C104.38,165,103.42,164.72,103.23,164.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.89,164a3.82,3.82,0,0,0,2.25-3c7.85-1.83,9.44-7.27,9.44-7.27,2.37,3.81,3.87,4.23,4.22,4.81a12.82,12.82,0,0,0-1.84-6.19,7.65,7.65,0,0,0-9-2.77,9,9,0,0,0-4,3.32,5.13,5.13,0,0,0-3.19,3.15C87.8,160,90.89,164,90.89,164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.64,153.4a6.46,6.46,0,0,1-1,3,8.26,8.26,0,0,1-2.23,2.37l-.69.44c-.23.13-.48.24-.73.37a9.85,9.85,0,0,1-1.51.59c-.52.16-1,.26-1.57.39s-1.07.14-1.6.19c.52-.13,1-.23,1.57-.35s1-.28,1.52-.46a12.1,12.1,0,0,0,2.82-1.44,8.52,8.52,0,0,0,2.21-2.23A7.7,7.7,0,0,0,102.64,153.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,164.4s-2.12-2.91-3.45-2.15.32,5,1.9,5.57a1.61,1.61,0,0,0,2.13-.9Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.23,163.46s0,0,0,0A4.05,4.05,0,0,1,91.37,166a.89.89,0,0,0-1.33-.22s0,.07,0,.06a1,1,0,0,1,1.09.32,4.86,4.86,0,0,1,.54.87c0,.1.23,0,.19-.07v0C91.88,165.52,90.75,163.57,89.23,163.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,324.46a17.19,17.19,0,0,1-7.95,8.73A16.91,16.91,0,0,1,98.53,335l-.29,0a16.8,16.8,0,0,1-2.47.18c-.35,0-.7,0-1,0l-.58-.05a17,17,0,0,1-6.38-1.89,17.25,17.25,0,0,1-9.11-13.09c1-2.09,3.65-1.8,4.62-4.12.06-.16.13-.35.21-.59A43.82,43.82,0,0,1,86,308.59l.05-.09a9.71,9.71,0,0,1,4.38-4.72,8.73,8.73,0,0,1,3.53-.69h0a11.4,11.4,0,0,1,1.35.08,12.29,12.29,0,0,1,2.33.49c.79.08,4.17-.43,6.54,2.59a12.11,12.11,0,0,1,1.67,3.7h0a62.77,62.77,0,0,1,1.52,6.8v0c.21,1.1.37,2,.5,2.65h0c0,.17.07.32.1.44.52,1.93,3.07,2.14,3.74,4.37A1.94,1.94,0,0,1,111.74,324.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.17,323.28a4.69,4.69,0,0,1-.2.6,3,3,0,0,0-.37-.76,8.68,8.68,0,0,0-1.85-1.83l-1-.84a2.75,2.75,0,0,1-.86-1,3.07,3.07,0,0,0,.94.89l1.1.75a8.71,8.71,0,0,1,2,1.81A3.11,3.11,0,0,1,112.17,323.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,308.5a22.21,22.21,0,0,0-.79,2.25L84.47,313a18.63,18.63,0,0,1-.91,2.23c0,.05,0,.09-.07.14a4.62,4.62,0,0,1-.58.93,1.69,1.69,0,0,1-.51.45l-.54.29a22.24,22.24,0,0,0-2.14,1,4.06,4.06,0,0,0-1.16,1q0-.31,0-.63a5.53,5.53,0,0,1,1-.74,22.89,22.89,0,0,1,2.16-1.08c.17-.09.35-.17.51-.27a.7.7,0,0,0,.21-.14.62.62,0,0,0,.18-.18,5,5,0,0,0,.61-1c.36-.69.65-1.43,1-2.16a40.64,40.64,0,0,1,1.85-4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,333.19A16.91,16.91,0,0,1,98.53,335l-.29,0a16.8,16.8,0,0,1-2.47.18c-.35,0-.7,0-1,0l-.58-.05a17,17,0,0,1-6.38-1.89,27.68,27.68,0,0,1,1.88-3.06v0l.23-.31h0a10.14,10.14,0,0,1,3.36-3c2.27-1.09,4.53-.46,6.58,1.07a6.39,6.39,0,0,1,.63.74C101.19,329.54,102.42,331.22,103.79,333.19Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,332.7A.29.29,0,0,0,88,333a.3.3,0,0,0,.59-.06A.3.3,0,0,0,88.23,332.7Zm3.92-.42a.31.31,0,0,0-.26.33.3.3,0,0,0,.33.26.3.3,0,0,0,.26-.32A.3.3,0,0,0,92.15,332.28Zm3.92-.41a.3.3,0,0,0,.06.59.3.3,0,1,0-.06-.59Zm3.92-.41a.29.29,0,1,0,.06.58.28.28,0,0,0,.26-.32A.29.29,0,0,0,100,331.46Zm-5.59,3.38a.3.3,0,0,0-.25.25l.58.05v0A.3.3,0,0,0,94.4,334.84Zm3.92-.41a.3.3,0,0,0-.26.32.3.3,0,0,0,.18.24l.29,0a.29.29,0,0,0,.12-.26A.3.3,0,0,0,98.32,334.43Zm-2.82-8a.29.29,0,0,0,.06.58.29.29,0,1,0-.06-.58Zm-5.59,3.38h0l-.23.31v0a.29.29,0,0,0,.32.24.29.29,0,0,0,.27-.32A.31.31,0,0,0,89.91,329.8Zm4-.41h0a.29.29,0,0,0-.26.32.29.29,0,0,0,.58,0v0A.29.29,0,0,0,93.88,329.39Zm3.87-.41a.29.29,0,0,0-.26.32.29.29,0,1,0,.58-.06A.28.28,0,0,0,97.75,329Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.56,329c.24.59,3.82,4.13,6.62,3.56.91-.19.1-5.21.1-5.21l0-.39.35-5.37-6.72-3-1-.38s0,1.48,0,3.32v.56c0,.27,0,.55,0,.83s0,.42,0,.65l0,.66A34.39,34.39,0,0,0,93.56,329Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,321.54a10.78,10.78,0,0,0,7.31,5.39l.35-5.37-6.72-3-1-.38S93,319.7,93,321.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.26,313.47c1,9.41-4.52,11.07-6.54,11.28-1.85.2-8.14.62-10.11-8.63s2.09-12.69,6.28-13.36S106.26,304.06,107.26,313.47Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.79,311.45a4.78,4.78,0,0,1-.65-.07,1,1,0,0,1-.65-.19.33.33,0,0,1,0-.41.83.83,0,0,1,.79-.28,1.2,1.2,0,0,1,.81.35A.36.36,0,0,1,104.79,311.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6,312.18c.21-.05.41-.13.62-.2a1.06,1.06,0,0,0,.59-.33.33.33,0,0,0,0-.41.82.82,0,0,0-.84-.1,1.18,1.18,0,0,0-.72.51A.36.36,0,0,0,98.6,312.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.1,314.42s0,0,0,.06c.11.64.12,1.38-.43,1.67,0,0,0,0,0,0C100.33,316,100.3,315,100.1,314.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.45,313.83c-1,.05-.85,2.12.11,2.07S100.31,313.78,99.45,313.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.05,314c-.17.14-.33.36-.55.4s-.46-.15-.64-.34c0,0,0,0,0,0,0,.4.22.79.65.81s.64-.36.7-.76C99.19,314,99.12,313.92,99.05,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8,313.93s0,0,0,.05c0,.64.18,1.38.78,1.54,0,0,0,0,0,0C103.91,315.52,103.73,314.54,103.8,313.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32,313.21c1-.17,1.28,1.9.33,2.05S103.46,313.35,104.32,313.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.76,313.29c.18.09.37.27.56.26s.37-.26.49-.49c0,0,0,0,0,0,.06.39,0,.82-.39.94s-.63-.19-.77-.58C104.65,313.37,104.69,313.26,104.76,313.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.79,319.54c.16.14.32.34.56.35a1.65,1.65,0,0,0,.68-.19,0,0,0,0,1,0,0,.86.86,0,0,1-.8.39.7.7,0,0,1-.53-.55S100.76,319.52,100.79,319.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,317a13.56,13.56,0,0,1,.27,1.39s-.1.08-.25.1h0a2.14,2.14,0,0,1-2.16-.58,0,0,0,0,1,.06-.07,3.28,3.28,0,0,0,2,.36c0-.13-.45-1.61-.38-1.62a3.63,3.63,0,0,1,1,.13c-.42-2-1.16-3.88-1.55-5.85,0-.07.09-.11.11,0a32.13,32.13,0,0,1,1.95,6.23C104.38,317.25,103.42,317,103.23,317Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.89,316.31a3.81,3.81,0,0,0,2.25-3c7.85-1.84,9.44-7.27,9.44-7.27,2.37,3.81,3.87,4.23,4.22,4.8a12.77,12.77,0,0,0-1.84-6.18,7.67,7.67,0,0,0-9-2.78,9,9,0,0,0-4,3.33,5.13,5.13,0,0,0-3.19,3.15C87.8,312.24,90.89,316.31,90.89,316.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.64,305.68a6.5,6.5,0,0,1-1,3.06,8.22,8.22,0,0,1-2.23,2.36l-.69.44c-.23.14-.48.25-.73.37a9.89,9.89,0,0,1-1.51.6c-.52.15-1,.26-1.57.39l-1.6.18,1.57-.34c.51-.16,1-.29,1.52-.47a11.73,11.73,0,0,0,2.82-1.44,8.37,8.37,0,0,0,2.21-2.23A7.63,7.63,0,0,0,102.64,305.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,316.69s-2.12-2.92-3.45-2.15.32,5,1.9,5.56a1.6,1.6,0,0,0,2.13-.9Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.23,315.74s0,0,0,0a4.08,4.08,0,0,1,2.14,2.49.89.89,0,0,0-1.33-.21s0,.06,0,.06a1,1,0,0,1,1.09.32,4.78,4.78,0,0,1,.54.86c0,.1.23,0,.19-.07v0C91.88,317.8,90.75,315.85,89.23,315.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.08,323.23c.09,2.38,2.16,22,4.06,24s9.84,5.34,15.84,6.24c8,1.18,18.77-1.83,23-5s6.75-26,5.56-27S351.37,314,341.88,314C330.73,314,317,321.08,317.08,323.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.55,345.37a73.36,73.36,0,0,0,9.22,3.93,28.74,28.74,0,0,0,9.77,1.81,44.71,44.71,0,0,0,9.89-1.36,86.74,86.74,0,0,0,9.58-2.93,70.71,70.71,0,0,1-9.53,3.11,45.61,45.61,0,0,1-9.94,1.45,29,29,0,0,1-9.83-1.92A60.06,60.06,0,0,1,320.55,345.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.11,342.77a75.06,75.06,0,0,0,9.6,4.1,30.26,30.26,0,0,0,10.2,1.9,46.82,46.82,0,0,0,10.31-1.43,89.85,89.85,0,0,0,10-3,73.57,73.57,0,0,1-9.95,3.23A46.94,46.94,0,0,1,339.91,349a29.94,29.94,0,0,1-10.25-2A62.76,62.76,0,0,1,320.11,342.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.74,340.35a79.07,79.07,0,0,0,9.95,4.24,31.4,31.4,0,0,0,10.56,2,48.9,48.9,0,0,0,10.68-1.48,91.35,91.35,0,0,0,10.34-3.17,74.11,74.11,0,0,1-10.3,3.34,49.12,49.12,0,0,1-10.72,1.57,31.18,31.18,0,0,1-10.62-2.07A66.21,66.21,0,0,1,319.74,340.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.07,338.12a76.44,76.44,0,0,0,9.95,4.24,30.81,30.81,0,0,0,10.55,2,49,49,0,0,0,10.69-1.47,91.35,91.35,0,0,0,10.34-3.17A76.37,76.37,0,0,1,351.3,343a49.12,49.12,0,0,1-10.72,1.57A31.33,31.33,0,0,1,330,342.53,65.25,65.25,0,0,1,320.07,338.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.71,335.54a82,82,0,0,0,10.3,4.4,32.51,32.51,0,0,0,10.93,2A51.16,51.16,0,0,0,352,340.45a95.89,95.89,0,0,0,10.71-3.29A80,80,0,0,1,352,340.62a50.68,50.68,0,0,1-11.1,1.62,32.28,32.28,0,0,1-11-2.14A68,68,0,0,1,319.71,335.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.12,332.72a83.48,83.48,0,0,0,10.58,4.52,33.24,33.24,0,0,0,11.23,2.09,51.3,51.3,0,0,0,11.35-1.57,97.66,97.66,0,0,0,11-3.37,84.23,84.23,0,0,1-10.95,3.55,52.21,52.21,0,0,1-11.4,1.66,33.27,33.27,0,0,1-11.29-2.2A69.64,69.64,0,0,1,319.12,332.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,330a86.32,86.32,0,0,0,11,4.7,34.3,34.3,0,0,0,11.66,2.17,53.5,53.5,0,0,0,11.8-1.63,100.26,100.26,0,0,0,11.42-3.51,84.33,84.33,0,0,1-11.38,3.68,53.73,53.73,0,0,1-11.84,1.73,34.48,34.48,0,0,1-11.71-2.28A72.61,72.61,0,0,1,318.66,330Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,327.45a85.56,85.56,0,0,0,11.28,4.82,35.16,35.16,0,0,0,12,2.24,54.54,54.54,0,0,0,12.12-1.68,104.46,104.46,0,0,0,11.73-3.6A88,88,0,0,1,353.45,333a55.35,55.35,0,0,1-12.15,1.77,35.68,35.68,0,0,1-12-2.34A75,75,0,0,1,318,327.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.66,263.8a3.59,3.59,0,0,0-2.24-4c-11.64-4-26.18-6.31-35.38-6.34h-.16c-9.21,0-23.76,2.3-35.39,6.34a3.58,3.58,0,0,0-2.25,4c1.76,10.83,3.32,48.32,12.08,65.05,4.85,9.29,23.79,9.34,25.56,9.31H342c1.77,0,20.69,0,25.56-9.31C376.35,312.12,377.9,274.63,379.66,263.8Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.98 255.74 324.5 265.79 324.94 275.84 325.72 295.94 326.32 316.05 326.57 326.1 326.73 336.16 326.21 326.12 325.76 316.07 324.99 295.96 324.38 275.86 324.14 265.8 323.98 255.74",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1,261.8a1.9,1.9,0,0,1-2.79,2,1.94,1.94,0,0,1-.91-1.28,1.89,1.89,0,1,1,3.7-.74Zm0,0a1.56,1.56,0,0,0-.76-1,1.53,1.53,0,1,0-.61,2.87,1.58,1.58,0,0,0,1.07-.58A1.55,1.55,0,0,0,321.1,261.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.79,273.84a1.9,1.9,0,0,1-1.3,2.19,2,2,0,0,1-1.49-.17,1.92,1.92,0,0,1-.91-1.27,2,2,0,0,1,.35-1.53,1.92,1.92,0,0,1,1.31-.73A1.9,1.9,0,0,1,321.79,273.84Zm0,0a1.54,1.54,0,0,0-.76-1,1.56,1.56,0,0,0-1.21-.12,1.53,1.53,0,1,0,1.68,2.41A1.61,1.61,0,0,0,321.79,273.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.23,286.63a1.9,1.9,0,0,1-1.3,2.19,2,2,0,0,1-1.49-.17,1.91,1.91,0,0,1-.56-2.8,1.89,1.89,0,0,1,3.35.78Zm0,0a1.53,1.53,0,0,0-.76-1,1.56,1.56,0,0,0-1.21-.11,1.53,1.53,0,1,0,1.67,2.4A1.55,1.55,0,0,0,322.23,286.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,299.42a1.89,1.89,0,0,1-2.79,2,1.89,1.89,0,1,1,2.79-2Zm0,0a1.6,1.6,0,0,0-.76-1,1.56,1.56,0,0,0-1.21-.12,1.53,1.53,0,0,0-1,1.76,1.52,1.52,0,0,0,2.68.65A1.58,1.58,0,0,0,322.67,299.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.11,312.2a1.9,1.9,0,0,1-1.3,2.19,2,2,0,0,1-1.49-.17,1.92,1.92,0,0,1-.91-1.27,1.89,1.89,0,1,1,3.7-.75Zm0,0a1.65,1.65,0,0,0-.76-1,1.56,1.56,0,0,0-1.21-.11,1.53,1.53,0,0,0,.6,3,1.5,1.5,0,0,0,1.07-.58A1.58,1.58,0,0,0,323.11,312.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.54,325a1.89,1.89,0,0,1-1.29,2.18,1.91,1.91,0,0,1-1.49-.16,2,2,0,0,1-.91-1.27,1.92,1.92,0,0,1,.34-1.53,1.94,1.94,0,0,1,1.31-.73A1.88,1.88,0,0,1,323.54,325Zm0,0a1.55,1.55,0,0,0-.75-1,1.52,1.52,0,0,0-1.21-.11,1.53,1.53,0,0,0,.6,3,1.6,1.6,0,0,0,1.07-.58A1.54,1.54,0,0,0,323.54,325Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.32,312.35c10.14,1.21,20.76-4.42,22-17.15,1.44-14.7-6.67-22.31-17.86-23.88-7.47-1-19.12,3.54-20.84,17.51C320.63,305.17,332.64,311.55,339.32,312.35Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M339.32,312.35c10.14,1.21,20.76-4.42,22-17.15,1.44-14.7-6.67-22.31-17.86-23.88-7.47-1-19.12,3.54-20.84,17.51C320.63,305.17,332.64,311.55,339.32,312.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M339.46,310.37c9.47,1.13,19.37-4.12,20.54-16,1.34-13.71-6.23-20.82-16.67-22.28-7-1-17.84,3.3-19.44,16.34C322,303.68,333.22,309.62,339.46,310.37Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M341.2,308.45c12-.94,16.83-12.16,13.74-22.87-1.84-7.45-8.9-11.39-16.27-9.94-7.17,1.69-11.58,8.87-11.61,16-.47,8.73,4.75,16.88,14.14,16.8Zm0,0c-9.37.23-14.86-8.09-14.65-16.8-.28-8.61,5.93-17.39,15.11-17.27a13.88,13.88,0,0,1,13.94,11c2.83,10.82-2.34,22.29-14.4,23.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M341.21,307.81c7.35-.36,14.47-6.09,14.32-16.11-.18-11.57-6.6-16.42-14.72-16.19-5.43.15-13.37,5.2-13.45,16.24C327.26,304.67,336.37,308.06,341.21,307.81Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.25,305.25c6.19-.31,12.18-5.13,12.05-13.55-.15-9.74-5.55-13.82-12.38-13.63-4.57.13-11.26,4.38-11.32,13.67C329.52,302.61,337.18,305.46,341.25,305.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.63,241.27c.06,1.69,1.53,15.63,2.89,17s7,3.79,11.26,4.43c5.65.84,13.34-1.3,16.33-3.58s4.8-18.46,4-19.2-10.06-5.23-16.81-5.23C334.33,234.74,324.58,239.74,324.63,241.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.1,257a52.3,52.3,0,0,0,6.55,2.78,20.47,20.47,0,0,0,7,1.3,32.18,32.18,0,0,0,7-1,61.52,61.52,0,0,0,6.81-2.08,50.12,50.12,0,0,1-6.78,2.2,32.36,32.36,0,0,1-7.06,1,20.64,20.64,0,0,1-7-1.37A42.61,42.61,0,0,1,327.1,257Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.78,255.17a54.72,54.72,0,0,0,6.83,2.91,21.74,21.74,0,0,0,7.25,1.35,33.7,33.7,0,0,0,7.33-1,65.35,65.35,0,0,0,7.1-2.18,51.18,51.18,0,0,1-7.07,2.3,33.89,33.89,0,0,1-7.36,1.08,21.91,21.91,0,0,1-7.29-1.42A45.79,45.79,0,0,1,326.78,255.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.52,253.44a55.16,55.16,0,0,0,7.08,3,22.44,22.44,0,0,0,7.5,1.4,35,35,0,0,0,7.6-1.05,70,70,0,0,0,7.35-2.25,55.29,55.29,0,0,1-7.32,2.37,35.15,35.15,0,0,1-7.63,1.12,22.6,22.6,0,0,1-7.54-1.47A47.66,47.66,0,0,1,326.52,253.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.75,251.86a55.77,55.77,0,0,0,7.08,3,22.44,22.44,0,0,0,7.5,1.4,35,35,0,0,0,7.6-1,67.08,67.08,0,0,0,7.35-2.26,53.9,53.9,0,0,1-7.32,2.38,35.68,35.68,0,0,1-7.63,1.12,22.6,22.6,0,0,1-7.54-1.47A47.66,47.66,0,0,1,326.75,251.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5,250a58.31,58.31,0,0,0,7.32,3.12,23,23,0,0,0,7.77,1.45,35.45,35.45,0,0,0,7.86-1.09,67.63,67.63,0,0,0,7.62-2.33,57,57,0,0,1-7.59,2.46,36.13,36.13,0,0,1-7.89,1.15,22.92,22.92,0,0,1-7.81-1.52A49.36,49.36,0,0,1,326.5,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.08,248a59.2,59.2,0,0,0,7.52,3.21,23.5,23.5,0,0,0,8,1.49,36.25,36.25,0,0,0,8.08-1.12,71.89,71.89,0,0,0,7.82-2.39,59,59,0,0,1-7.79,2.52,36.93,36.93,0,0,1-8.11,1.18,23.67,23.67,0,0,1-8-1.56A50,50,0,0,1,326.08,248Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.75,246.11a62.37,62.37,0,0,0,7.81,3.34,24.54,24.54,0,0,0,8.29,1.54,37.78,37.78,0,0,0,8.39-1.16,69.64,69.64,0,0,0,8.11-2.49,60,60,0,0,1-8.08,2.62,38.63,38.63,0,0,1-8.42,1.22,24.47,24.47,0,0,1-8.33-1.62A51.34,51.34,0,0,1,325.75,246.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.31,244.27a61.59,61.59,0,0,0,8,3.43,24.92,24.92,0,0,0,8.52,1.59,39.25,39.25,0,0,0,8.61-1.19,76.4,76.4,0,0,0,8.34-2.56,61.9,61.9,0,0,1-8.31,2.68,38.85,38.85,0,0,1-8.64,1.26,25.28,25.28,0,0,1-8.56-1.66A53.15,53.15,0,0,1,325.31,244.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,243.84c0-.21,4.29-1,8.36-1.63a10.29,10.29,0,0,0,8.48-8.56l5.52-35.54A10.27,10.27,0,0,0,426,187l-11.32-4.56Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M410,243.84c0-.21,4.29-1,8.36-1.63a10.29,10.29,0,0,0,8.48-8.56l5.52-35.54A10.27,10.27,0,0,0,426,187l-11.32-4.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M275.56,242.64c0-.21-4.31-.81-8.41-1.34a10.28,10.28,0,0,1-8.77-8.27l-6.74-35.33a10.27,10.27,0,0,1,5.94-11.31l11.16-4.95Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275.56,242.64c0-.21-4.31-.81-8.41-1.34a10.28,10.28,0,0,1-8.77-8.27l-6.74-35.33a10.27,10.27,0,0,1,5.94-11.31l11.16-4.95Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.3,252.57s8.19-44.87,9.39-115.14c0,0-84.78-13.22-154-.8,0,0,3.11,88.88,8.9,113.77C274.61,250.4,345.37,254.11,410.3,252.57Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,131.37q0,15.06.13,30.12l.31,30.11.34-.37-34.14,2.49L288.19,195l-17.07,1.4,17.09-1,17.09-1.1L339.45,192l.35,0v-.34l-.5-30.12Q339,146.42,338.62,131.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.36,135.9a1.93,1.93,0,0,1,1.78,2.25,2,2,0,0,1-.88,1.34,2,2,0,0,1-1.52.23,1.95,1.95,0,0,1,.62-3.82Zm-1.68,2.9a1.59,1.59,0,0,0,1.12.55,1.57,1.57,0,0,0,.5-3.08,1.6,1.6,0,0,0-1.24.16,1.66,1.66,0,0,0-.73,1.1A1.61,1.61,0,0,0,341.68,138.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.13,148.27a1.9,1.9,0,0,1,1.36.7,1.94,1.94,0,0,1,.42,1.54,1.93,1.93,0,0,1-2.4,1.57,1.94,1.94,0,0,1,.62-3.81Zm-1.69,2.9a1.57,1.57,0,1,0,1.63-2.53,1.57,1.57,0,0,0-1.63,2.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.18,161.38a2,2,0,0,1,1.37.7,2,2,0,0,1,.41,1.55,2,2,0,0,1-.88,1.34,1.94,1.94,0,1,1-.9-3.59Zm-1.69,2.9a1.63,1.63,0,0,0,1.13.55,1.57,1.57,0,0,0,.5-3.08,1.6,1.6,0,0,0-1.24.17,1.55,1.55,0,0,0-.73,1.09A1.6,1.6,0,0,0,341.49,164.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.23,174.5a1.94,1.94,0,1,1-.62,3.81,1.94,1.94,0,0,1,.62-3.81Zm-1.68,2.9a1.59,1.59,0,0,0,1.12.55,1.57,1.57,0,0,0,.5-3.08,1.6,1.6,0,0,0-1.24.16,1.63,1.63,0,0,0-.73,1.1A1.61,1.61,0,0,0,341.55,177.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.7,193.7a1.94,1.94,0,1,1-.62,3.81,1.94,1.94,0,0,1,.62-3.81ZM331,196.6a1.56,1.56,0,1,0,1.62-2.53,1.6,1.6,0,0,0-1.24.16,1.59,1.59,0,0,0-.38,2.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.17,194.68a1.94,1.94,0,1,1-2,1.63A2,2,0,0,1,320.17,194.68Zm-1.69,2.9a1.61,1.61,0,0,0,1.13.55,1.57,1.57,0,0,0,.5-3.08,1.57,1.57,0,0,0-1.63,2.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,195.67a1.94,1.94,0,0,1,1.37.7,2,2,0,0,1,.42,1.55,1.94,1.94,0,0,1-2.41,1.57,1.95,1.95,0,0,1,.62-3.82Zm-1.68,2.9a1.57,1.57,0,1,0,1.62-2.53,1.57,1.57,0,0,0-1.62,2.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.1,196.66a1.94,1.94,0,1,1-.62,3.81,1.94,1.94,0,0,1,.62-3.81Zm-1.68,2.9a1.59,1.59,0,0,0,1.12.55A1.57,1.57,0,0,0,295,197a1.6,1.6,0,0,0-1.24.16,1.63,1.63,0,0,0-.73,1.1A1.61,1.61,0,0,0,293.42,199.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.42,197.63a2,2,0,0,1,1.42.59,2,2,0,0,1-.25,2.91,1.94,1.94,0,1,1-1.17-3.5Zm-1.46,3a1.65,1.65,0,0,0,1.17.46,1.57,1.57,0,1,0-1.61-1.7A1.62,1.62,0,0,0,281,200.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.28,187.61a2,2,0,0,1,1.37.7,1.95,1.95,0,0,1-.47,2.89,1.94,1.94,0,1,1-.9-3.59Zm-1.68,2.9a1.56,1.56,0,0,0,2.73-.77,1.57,1.57,0,0,0-2.35-1.59,1.58,1.58,0,0,0-.38,2.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,245.07s7.05-36.82,8.09-97.69c0,0-84.65-10.79-133.39-.69,0,0,2.73,74.93,7.75,96.49C283.57,243.18,344.87,246.4,401.12,245.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.91,149.09c.52,13,3.18,74.83,7.66,94.09,0,0,58.94,3.1,114.26,2,1.09-6.16,6.83-40.83,7.7-94.79C405.53,150.35,324.33,140,275.91,149.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.24,
    y1: 145.59,
    x2: 321.48,
    y2: 145.37,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,145.77l-31.05-.33c1.59,0,3.18-.06,4.77-.07,7-.08,14,0,20.76.22C344.09,145.64,345.94,145.71,347.76,145.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.88,
    y1: 148.1,
    x2: 289.65,
    y2: 147.09,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.39,148.24l-96.72-1,1-.11,1.08-.12,91.49,1h.06l1.6.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.53,
    y1: 150.4,
    x2: 276.37,
    y2: 149.01,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.53,150.35v.17l-129.62-1.4v0l.46-.08c.23,0,.45-.09.68-.12l127.76,1.37h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.5,
    y1: 152.46,
    x2: 275.99,
    y2: 151.07,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,152.33a.28.28,0,0,0,0,.13.49.49,0,0,0,0,.12L276,151.19a.49.49,0,0,1,0-.12v-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.45,
    y1: 154.52,
    x2: 276.08,
    y2: 153.13,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45,154.39v.25l-129.37-1.39v-.12s0-.09,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.41,
    y1: 156.57,
    x2: 276.17,
    y2: 155.19,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,156.45v.12a.62.62,0,0,0,0,.13l-129.22-1.39a.49.49,0,0,1,0-.12.62.62,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.36,
    y1: 158.63,
    x2: 276.26,
    y2: 157.25,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.36,158.51v.12a.62.62,0,0,0,0,.13l-129.08-1.39a.49.49,0,0,1,0-.12.56.56,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.3,
    y1: 160.69,
    x2: 276.35,
    y2: 159.31,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.3,160.57v.12a.53.53,0,0,1,0,.13l-128.93-1.38c0-.05,0-.09,0-.13v-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.24,
    y1: 162.75,
    x2: 276.45,
    y2: 161.37,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.24,162.63v.12a.57.57,0,0,0,0,.13L276.46,161.5a.57.57,0,0,1,0-.13s0-.08,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.17,
    y1: 164.81,
    x2: 276.55,
    y2: 163.43,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.17,164.69v.12a.57.57,0,0,1,0,.13l-128.6-1.38a.57.57,0,0,1,0-.13.49.49,0,0,1,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.1,
    y1: 166.88,
    x2: 276.65,
    y2: 165.5,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1,166.75v.13s0,.08,0,.12l-128.43-1.38a.49.49,0,0,1,0-.12.57.57,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.02,
    y1: 168.94,
    x2: 276.75,
    y2: 167.56,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,168.81v.13a.49.49,0,0,1,0,.12l-128.26-1.37v-.13s0-.08,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.94,
    y1: 171,
    x2: 276.85,
    y2: 169.62,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.94,170.87V171s0,.08,0,.12l-128.07-1.37s0-.09,0-.13a.49.49,0,0,0,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.85,
    y1: 173.06,
    x2: 276.96,
    y2: 171.68,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.86,172.93a.62.62,0,0,0,0,.13v.12L277,171.81a.57.57,0,0,1,0-.13s0-.08,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.76,
    y1: 175.12,
    x2: 277.07,
    y2: 173.75,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.76,175v.13a.49.49,0,0,0,0,.12l-127.68-1.37v-.12a.62.62,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.66,
    y1: 177.18,
    x2: 277.18,
    y2: 175.81,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.67,177.05a.57.57,0,0,0,0,.13.48.48,0,0,0,0,.12l-127.48-1.37v-.12s0-.09,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.56,
    y1: 179.24,
    x2: 277.3,
    y2: 177.87,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.56,179.11v.13a.49.49,0,0,0,0,.12L277.3,178a.48.48,0,0,1,0-.12.57.57,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.44,
    y1: 181.3,
    x2: 277.41,
    y2: 179.93,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.45,181.18a.49.49,0,0,1,0,.12v.13l-127-1.37v-.13a.49.49,0,0,1,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.33,
    y1: 183.36,
    x2: 277.52,
    y2: 182,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.34,183.24a.49.49,0,0,0,0,.12v.12l-126.8-1.36a.49.49,0,0,0,0-.12v-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.21,
    y1: 185.42,
    x2: 277.65,
    y2: 184.06,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.22,185.29s0,.09,0,.13v.12l-126.55-1.36a.49.49,0,0,1,0-.12.57.57,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.08,
    y1: 187.47,
    x2: 277.77,
    y2: 186.12,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.09,187.35a.49.49,0,0,1,0,.12v.13l-126.31-1.35v-.13s0-.08,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.95,
    y1: 189.53,
    x2: 277.89,
    y2: 188.18,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,189.41a.49.49,0,0,1,0,.12.57.57,0,0,1,0,.13l-126-1.35a.53.53,0,0,0,0-.13.49.49,0,0,0,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.82,
    y1: 191.59,
    x2: 278.03,
    y2: 190.24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.82,191.47v.12a.57.57,0,0,0,0,.13L278,190.37a.56.56,0,0,1,0-.13.49.49,0,0,1,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.67,
    y1: 193.66,
    x2: 278.15,
    y2: 192.3,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.68,193.53s0,.09,0,.13a.49.49,0,0,1,0,.12l-125.5-1.35a.62.62,0,0,0,0-.13v-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.52,
    y1: 195.72,
    x2: 278.29,
    y2: 194.37,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.53,195.59a.57.57,0,0,1,0,.13.49.49,0,0,1,0,.12L278.3,194.49a.49.49,0,0,1,0-.12s0-.09,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.37,
    y1: 197.78,
    x2: 278.43,
    y2: 196.43,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.37,197.65v.13a.49.49,0,0,0,0,.12l-124.92-1.34s0-.09,0-.13,0-.08,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.2,
    y1: 199.83,
    x2: 278.57,
    y2: 198.49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.21,199.71a.49.49,0,0,1,0,.12.57.57,0,0,1,0,.13l-124.61-1.34a.62.62,0,0,0,0-.13v-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.04,
    y1: 201.89,
    x2: 278.72,
    y2: 200.56,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.05,201.76s0,.09,0,.13,0,.08,0,.12l-124.3-1.33s0-.08,0-.12,0-.08,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.87,
    y1: 203.95,
    x2: 278.87,
    y2: 202.62,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.88,203.82s0,.09,0,.13a.49.49,0,0,0,0,.12l-124-1.33s0-.08,0-.12a.57.57,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.68,
    y1: 206.01,
    x2: 279.02,
    y2: 204.68,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.7,205.88a.69.69,0,0,1,0,.13.25.25,0,0,1,0,.12L279,204.8a.49.49,0,0,0,0-.12.57.57,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.5,
    y1: 208.07,
    x2: 279.18,
    y2: 206.75,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.51,208a.49.49,0,0,1,0,.12s0,.09,0,.13l-123.3-1.33a.49.49,0,0,0,0-.12.62.62,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.31,
    y1: 210.13,
    x2: 279.35,
    y2: 208.81,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.32,210s0,.08,0,.12,0,.09,0,.13l-122.94-1.33s0-.08,0-.12,0-.09,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.11,
    y1: 212.19,
    x2: 279.52,
    y2: 210.87,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.12,212.06a.53.53,0,0,1,0,.13s0,.08,0,.12L279.53,211s0-.08,0-.12,0-.08,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.91,
    y1: 214.24,
    x2: 279.7,
    y2: 212.93,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.92,214.12s0,.08,0,.12a.53.53,0,0,0,0,.13l-122.19-1.31a.57.57,0,0,1,0-.13.49.49,0,0,1,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.69,
    y1: 216.3,
    x2: 279.87,
    y2: 214.99,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.71,216.18s0,.08,0,.12,0,.09,0,.13l-121.8-1.31a.57.57,0,0,0,0-.13.49.49,0,0,0,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.47,
    y1: 218.36,
    x2: 280.06,
    y2: 217.06,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.48,218.24a.49.49,0,0,1,0,.12s0,.09,0,.13l-121.39-1.3a.53.53,0,0,0,0-.13s0-.08,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.25,
    y1: 220.43,
    x2: 280.25,
    y2: 219.12,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.26,220.3s0,.09,0,.13,0,.08,0,.12l-121-1.3s0-.09,0-.13a.49.49,0,0,0,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.01,
    y1: 222.48,
    x2: 280.46,
    y2: 221.18,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,222.36a.49.49,0,0,1,0,.12.51.51,0,0,1,0,.13l-120.52-1.3s0-.08,0-.13,0-.08,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.77,
    y1: 224.54,
    x2: 280.67,
    y2: 223.25,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.79,224.41s0,.09,0,.13,0,.08,0,.12l-120.07-1.29a.5.5,0,0,1,0-.12.57.57,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.52,
    y1: 226.6,
    x2: 280.89,
    y2: 225.31,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.54,226.47s0,.09,0,.13a.5.5,0,0,1,0,.12l-119.59-1.28a.51.51,0,0,1,0-.13.49.49,0,0,1,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.26,
    y1: 228.66,
    x2: 281.12,
    y2: 227.38,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.28,228.53s0,.09,0,.13a.5.5,0,0,1,0,.12l-119.1-1.28a.5.5,0,0,1,0-.12.57.57,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 230.72,
    x2: 281.36,
    y2: 229.44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,230.59a.59.59,0,0,0,0,.13s0,.08,0,.12l-118.6-1.28s0-.08,0-.12,0-.08,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.72,
    y1: 232.77,
    x2: 281.63,
    y2: 231.5,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.74,232.64s0,.09,0,.13,0,.08,0,.12l-118.07-1.26a.53.53,0,0,1,0-.13.59.59,0,0,1,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.44,
    y1: 234.83,
    x2: 281.9,
    y2: 233.57,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.45,234.71s0,.08,0,.12a.69.69,0,0,0,0,.13l-117.5-1.27a.5.5,0,0,1,0-.12s0-.09,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.14,
    y1: 236.89,
    x2: 282.2,
    y2: 235.63,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.16,236.77s0,.08,0,.12,0,.08,0,.12l-116.9-1.26a10.13,10.13,0,0,1,0-.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.84,
    y1: 238.94,
    x2: 282.51,
    y2: 237.7,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,238.82a.5.5,0,0,0,0,.12.69.69,0,0,0,0,.13l-116.29-1.25a.5.5,0,0,0,0-.12.69.69,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.52,
    y1: 241,
    x2: 282.87,
    y2: 239.76,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.54,240.88a.5.5,0,0,0,0,.12.59.59,0,0,0,0,.13l-115.61-1.24a.59.59,0,0,0,0-.13s0-.08,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.18,
    y1: 243.06,
    x2: 283.27,
    y2: 241.82,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2,242.94a10.13,10.13,0,0,0,0,.25L283.3,242l0-.13a.5.5,0,0,1,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "305.87 244.13 305.96 244.13 397.83 245.11",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.85,245a.5.5,0,0,1,0,.12v0l-3.54.07-83-.9-5.34-.18h-.09l-4.6-.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.75,206.58a10.5,10.5,0,0,0,1.78,6.64,7.52,7.52,0,0,0,2.77,2.44,8.74,8.74,0,0,0,3.62.89,6.86,6.86,0,0,0,6.31-3.56,11.62,11.62,0,0,0,1.47-6.71,18.18,18.18,0,0,1-2.77,5.83,5.87,5.87,0,0,1-5,2.44,7,7,0,0,1-5.23-2.3A14.72,14.72,0,0,1,333.75,206.58Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78,203.17c6.39-.11,6.13,12.67.21,12.77S371.43,203.26,376.78,203.17Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,202.32c6.38-.11,6.13,12.67.21,12.77S299.22,202.41,304.58,202.32Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.38,203.27a314.81,314.81,0,0,1-3.75-48.39l0-1.6a165.46,165.46,0,0,1,26.51-3.85,172.22,172.22,0,0,1,25.09.06c-16.37,2-33,3.66-49.09,7.32l1.51-1.94c0,4,0,8,.05,12.07,0,12.11.14,24.22-.3,36.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,430.16s5.6,3.06,18.73,2.52,18.45-4,18.45-4-3.78-47.43-11-69.63c-2.61-8-5-15.14-12.65-14.83-8.9.36-10.09,7.53-11.39,15.82C343.13,380.43,344.26,430.16,344.26,430.16Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.05,
    y: 416.18,
    width: 10.83,
    height: 19.87,
    transform: "translate(748.05 836.92) rotate(177.65)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.25,430.16s5.61,3.06,18.75,2.52,18.44-4,18.44-4-.1-2.25-.31-6a27.33,27.33,0,0,0-16-4,26.82,26.82,0,0,0-20.84,10.41C344.28,429.78,344.25,430.16,344.25,430.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.48,444.84h63.27s-4-23.34-29.29-22.45A37.78,37.78,0,0,0,336.48,444.84Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.18,437.68c0,3.95,2.81,7.16,6.27,7.16s6.27-3.21,6.27-7.16-2.81-7.16-6.27-7.16S340.18,433.72,340.18,437.68Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.18,437.68c0,3.95,2.81,7.16,6.27,7.16s6.27-3.21,6.27-7.16-2.81-7.16-6.27-7.16S340.18,433.72,340.18,437.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.19,430.16s-5.6,3.06-18.74,2.52-18.45-4-18.45-4,3.78-47.43,11-69.63c2.6-8,5-15.14,12.65-14.83,8.9.36,10.08,7.53,11.39,15.82C338.32,380.43,337.19,430.16,337.19,430.16Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.57,
    y: 416.18,
    width: 10.83,
    height: 19.87,
    transform: "translate(17.7 -12.57) rotate(2.35)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.19,430.16s-5.6,3.06-18.74,2.52-18.44-4-18.44-4,.1-2.25.3-6a27.35,27.35,0,0,1,16-4,26.78,26.78,0,0,1,20.83,10.41C337.17,429.78,337.19,430.16,337.19,430.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,444.84H281.69s4-23.34,29.3-22.45A37.78,37.78,0,0,1,345,444.84Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.27,437.68c0,3.95-2.81,7.16-6.28,7.16s-6.27-3.21-6.27-7.16,2.81-7.16,6.27-7.16S341.27,433.72,341.27,437.68Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.27,437.68c0,3.95-2.81,7.16-6.28,7.16s-6.27-3.21-6.27-7.16,2.81-7.16,6.27-7.16S341.27,433.72,341.27,437.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.18,348.75c.43.14,2.86,8.65,2.89,9.35a6.82,6.82,0,0,1-2.51,4c-1.57,1.18-4.49,1.54-5,1.18s-4.5-8.2-4.52-9.14S297.82,347.26,302.18,348.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,354.13c0,.93,4,8.78,4.52,9.14a1.71,1.71,0,0,0,.85.14c-.8-2.77-2.07-7.29-2.18-8.24-.15-1.32,1.71-4.71,3.21-6.49C296,349.54,293,353.39,293,354.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.42,363.81c-.63,1.12-3.62,1.54-6.47.52-1.27-.45-3.93-6.66-4.06-8.76a84.71,84.71,0,0,1,0-9c.18-.58,7.71,1.72,8.12,2.35s0,7.2.72,9.75S286.64,363.42,286.42,363.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19,346.78c1.69,1.82,2.15,6,2.56,7.46.36,1.3,3.41,7.56,4.76,10.28a1.79,1.79,0,0,0,.91-.71c.22-.39-.9-2.62-1.65-5.18s-.31-9.12-.72-9.75C283.78,348.47,280.5,347.35,278.19,346.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,352.2c.49.29,3.8,10.93,3.76,11.48-.11,1.35-3,3.51-4.57,3.85s-5.85-1.5-6.26-1.83a52.25,52.25,0,0,1-3.52-6.34,58.56,58.56,0,0,1-1-9.23C282.56,349.91,293.4,351.85,294,352.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,337.56c.05,1.47,1.33,13.57,2.51,14.81s6.07,3.29,9.78,3.84c4.91.74,11.59-1.12,14.18-3.11s4.17-16,3.44-16.67-8.74-4.54-14.6-4.54C282.76,331.89,274.28,336.23,274.33,337.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.47,351.24a46.71,46.71,0,0,0,5.69,2.42,17.89,17.89,0,0,0,6,1.12,28.1,28.1,0,0,0,6.11-.84,53,53,0,0,0,5.91-1.81,44.52,44.52,0,0,1-5.89,1.92,28.08,28.08,0,0,1-6.13.89,17.94,17.94,0,0,1-6.07-1.18A37.24,37.24,0,0,1,276.47,351.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.2,349.63a47.58,47.58,0,0,0,5.93,2.53,18.63,18.63,0,0,0,6.29,1.17,29.18,29.18,0,0,0,6.37-.88,53.53,53.53,0,0,0,6.17-1.89,44,44,0,0,1-6.14,2,28.74,28.74,0,0,1-6.39.93,18.45,18.45,0,0,1-6.33-1.23A39.43,39.43,0,0,1,276.2,349.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,348.13a49,49,0,0,0,6.15,2.62,19.17,19.17,0,0,0,6.52,1.22,30,30,0,0,0,6.59-.92,57.37,57.37,0,0,0,6.39-1.95,47.63,47.63,0,0,1-6.36,2.06,30.24,30.24,0,0,1-6.62,1,19.37,19.37,0,0,1-6.56-1.28A40.19,40.19,0,0,1,276,348.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,346.76a49,49,0,0,0,6.15,2.62,19.4,19.4,0,0,0,6.52,1.21,30,30,0,0,0,6.59-.91,57.37,57.37,0,0,0,6.39-1.95,47.17,47.17,0,0,1-6.36,2.06,30.85,30.85,0,0,1-6.62,1,19.37,19.37,0,0,1-6.56-1.28A41.2,41.2,0,0,1,276.17,346.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,345.16a50.88,50.88,0,0,0,6.36,2.72,20.07,20.07,0,0,0,6.75,1.26,31,31,0,0,0,6.83-.95,58.59,58.59,0,0,0,6.61-2,48.55,48.55,0,0,1-6.58,2.13,31.83,31.83,0,0,1-6.86,1,20.12,20.12,0,0,1-6.78-1.32A41.67,41.67,0,0,1,276,345.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.59,343.42a50.07,50.07,0,0,0,6.53,2.79,20.39,20.39,0,0,0,6.93,1.29,32,32,0,0,0,7-1,61.9,61.9,0,0,0,6.79-2.09,50,50,0,0,1-6.77,2.19,32.08,32.08,0,0,1-7,1,20.46,20.46,0,0,1-7-1.36A42.45,42.45,0,0,1,275.59,343.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.31,341.76a53.36,53.36,0,0,0,6.78,2.9,21.16,21.16,0,0,0,7.2,1.34,33.24,33.24,0,0,0,7.28-1,61.73,61.73,0,0,0,7.05-2.17,50.84,50.84,0,0,1-7,2.27,33.52,33.52,0,0,1-7.31,1.07,21.57,21.57,0,0,1-7.24-1.41A44.64,44.64,0,0,1,275.31,341.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,340.17a54.9,54.9,0,0,0,7,3,22,22,0,0,0,7.39,1.38,33.79,33.79,0,0,0,7.48-1,61.29,61.29,0,0,0,7.25-2.23,52.41,52.41,0,0,1-7.22,2.34,34.64,34.64,0,0,1-7.51,1.09,21.94,21.94,0,0,1-7.43-1.44A47.16,47.16,0,0,1,274.92,340.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,270.52c-1.41,7.1.7,14.15,4.72,15.77s8.42-2.83,9.83-9.92-.7-14.15-4.72-15.77S301,263.43,299.57,270.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,270.57c-1.2,6,.59,11.94,4,13.3l.19.07c3.35,1.16,6.94-2.56,8.11-8.44,1-5.29-.23-10.57-2.9-12.66a4.61,4.61,0,0,0-1.09-.63C304.6,260.85,300.88,264.59,299.7,270.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,271.26c-1.05,5.3.23,10.59,2.89,12.68,3.35,1.16,6.94-2.56,8.11-8.44,1-5.29-.23-10.57-2.9-12.66C305.73,261.68,302.14,265.4,301,271.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,268.56l3.72,1.12c.38.11.89,1.95.62,3.89s-1.22,3.24-1.6,3.13L303,275.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,268.56c-.67-.19-1.43,1.22-1.71,3.16s.05,3.67.72,3.86,1.43-1.22,1.7-3.16S304.65,268.75,304,268.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.8,346.1s-10.71,3.93-20.05,1.34c-10.76-3-13-8.49-13-8.49S285,286.08,295,272c3.57-5.05,7.91-11.41,12.14-7.7,2.22,1.94,4.09,14.75,3.21,20.87C308.16,300.29,304.8,346.1,304.8,346.1Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6,311.75s-12.57-1.27-19.48-6l-1.92,6.43s7.32,4.54,20.7,5.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,325.65H302c4.13.42,7.93-3.7,8.48-9.23.5-4.89-1.67-9.25-5-10.56a5.89,5.89,0,0,0-1.46-.36c-4.15-.46-8,3.67-8.55,9.23S297.83,325.19,302,325.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,325.66c4.13.42,7.93-3.7,8.48-9.23.5-4.89-1.67-9.25-5-10.56-4.13-.42-7.92,3.71-8.48,9.24C296.51,320,298.69,324.35,302,325.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,270.52c1.41,7.1-.7,14.15-4.72,15.77s-8.42-2.83-9.83-9.92.7-14.15,4.72-15.77S383.21,263.43,384.62,270.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.49,270.57c1.2,6-.59,11.94-4,13.3l-.19.07c-3.35,1.16-6.94-2.56-8.11-8.44-1.05-5.29.23-10.57,2.9-12.66a4.61,4.61,0,0,1,1.09-.63C379.59,260.85,383.31,264.59,384.49,270.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.22,271.26c1,5.3-.23,10.59-2.89,12.68-3.35,1.16-6.94-2.56-8.11-8.44-1.05-5.29.23-10.57,2.9-12.66C378.46,261.68,382.05,265.4,383.22,271.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.21,268.56l-3.73,1.12c-.38.11-.89,1.95-.62,3.89s1.22,3.24,1.6,3.13l3.73-1.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.21,268.56c.66-.19,1.42,1.22,1.7,3.16s-.05,3.67-.72,3.86-1.43-1.22-1.7-3.16S379.54,268.75,380.21,268.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.92,310c-11.69-9.64-22.81-19.41-27.17-24-4.55-4.75-8.18-15.53-7.47-18.58,1.37-5.82,9-3,15.25-.85,7.69,2.67,20.7,11.56,32.78,20.61C420.22,297.41,417,306.07,407.92,310Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.07,274.38c.43.12,7.25-5.52,7.66-6.08a6.71,6.71,0,0,0,.19-4.72c-.62-1.85-2.83-3.8-3.48-3.81s-8.35,4.22-8.89,5S441.63,273.14,446.07,274.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.55,264.76c.54-.77,8.24-5,8.89-5a1.73,1.73,0,0,1,.78.37C449,262,445.4,265,444.77,265.7c-.87,1-1.25,4.86-1,7.17C441.42,270.23,441.12,265.36,441.55,264.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.51,245.89c-.22-1.27-2.89-2.68-5.92-2.68-1.35,0-5.94,4.94-6.78,6.88a85.7,85.7,0,0,0-3,8.52c0,.61,7.84,1,8.44.53s2.41-6.78,4-8.94S443.58,246.33,443.51,245.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,259.14c2.2-1.15,4-4.91,4.93-6.16.77-1.1,5.76-6,7.95-8.07a1.86,1.86,0,0,1,.62,1c.07.45-1.74,2.17-3.31,4.32s-3.37,8.48-4,8.94C435.84,259.43,432.37,259.38,430,259.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.92,265.49c.57-.05,8.15-8.22,8.34-8.74.49-1.26-1.16-4.45-2.46-5.44s-5.93-1.17-6.44-1.05a52.2,52.2,0,0,0-5.9,4.2,57.32,57.32,0,0,0-4.91,7.88C431.63,262.63,442.25,265.56,442.92,265.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.42,263.6c1.1-1,10.7-8.45,12.41-8.46s6.58,2.09,9.55,4.38c3.94,3,7.23,9.13,7.6,12.37s-8.65,14.13-9.62,14-9.34-3.14-13.4-7.36C419.18,273.61,416.43,264.49,417.42,263.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.76,255.66a46.71,46.71,0,0,1,5.69,2.42,17.76,17.76,0,0,1,5,3.57,28.22,28.22,0,0,1,3.63,5,55,55,0,0,1,2.8,5.52,42.74,42.74,0,0,0-2.71-5.57,28.36,28.36,0,0,0-3.6-5A18.08,18.08,0,0,0,434.5,258,38.07,38.07,0,0,0,428.76,255.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.41,256.58a45.61,45.61,0,0,1,5.94,2.52,18.56,18.56,0,0,1,5.21,3.72,28.44,28.44,0,0,1,3.78,5.2,53.49,53.49,0,0,1,2.92,5.75,45.1,45.1,0,0,0-2.82-5.81,29,29,0,0,0-3.76-5.25A18.74,18.74,0,0,0,433.4,259,39.29,39.29,0,0,0,427.41,256.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.18,257.46a46.68,46.68,0,0,1,6.15,2.61,19.09,19.09,0,0,1,5.39,3.85,30.12,30.12,0,0,1,3.92,5.38,55.51,55.51,0,0,1,3,6,46.27,46.27,0,0,0-2.92-6,30.32,30.32,0,0,0-3.9-5.44,19.27,19.27,0,0,0-5.46-3.84A40.44,40.44,0,0,0,426.18,257.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.33,258.55a49.53,49.53,0,0,1,6.15,2.61,19.29,19.29,0,0,1,5.39,3.85,30.06,30.06,0,0,1,3.92,5.39,54.59,54.59,0,0,1,3,6,46.4,46.4,0,0,0-2.92-6,30.68,30.68,0,0,0-3.9-5.44,19.47,19.47,0,0,0-5.46-3.84A42.12,42.12,0,0,0,425.33,258.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,259.5a48.29,48.29,0,0,1,6.37,2.7,19.81,19.81,0,0,1,5.59,4,31.4,31.4,0,0,1,4.06,5.57,59.44,59.44,0,0,1,3.12,6.17,48.27,48.27,0,0,0-3-6.22,31.13,31.13,0,0,0-4-5.64,20.16,20.16,0,0,0-5.66-4A42.08,42.08,0,0,0,424,259.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.52,260.44a51.55,51.55,0,0,1,6.54,2.78,20.5,20.5,0,0,1,5.74,4.09A32.67,32.67,0,0,1,439,273a59.72,59.72,0,0,1,3.2,6.34,50.38,50.38,0,0,0-3.11-6.4,32.74,32.74,0,0,0-4.14-5.78,20.68,20.68,0,0,0-5.81-4.08A44.82,44.82,0,0,0,422.52,260.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.13,261.39a52.57,52.57,0,0,1,6.79,2.88,21.18,21.18,0,0,1,6,4.25,33.41,33.41,0,0,1,4.33,6,64.39,64.39,0,0,1,3.33,6.58,52.9,52.9,0,0,0-3.24-6.64,33.35,33.35,0,0,0-4.3-6,21.36,21.36,0,0,0-6-4.24A45.59,45.59,0,0,0,421.13,261.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.71,262.22a54.87,54.87,0,0,1,7,2.95,22,22,0,0,1,6.12,4.37,33.88,33.88,0,0,1,4.45,6.11,65.87,65.87,0,0,1,3.42,6.76,54.27,54.27,0,0,0-3.33-6.81,33.55,33.55,0,0,0-4.42-6.17,21.73,21.73,0,0,0-6.19-4.35A46,46,0,0,0,419.71,262.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.27,290.6c8.47-15.57,17.37-29.82,17.37-29.82s5.52-2.21,15.13,3.47c8.35,4.94,12.94,15.38,12.94,15.38s-11.56,16.4-26.1,27.72C402.6,305.3,403.86,299.23,399.27,290.6Z",
    style: {
      fill: "#079DCA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.77,300.71s2-16.74-1.06-24.54l2.1-.12s7,12.08,5.33,25.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,305.22s0,0,0,0c-.52,4.12-5.39,6.88-10.91,6.16-4.87-.62-8.62-3.72-9.13-7.29a5.38,5.38,0,0,1,0-1.5c.49-4.15,5.38-6.94,10.93-6.23S420.5,301.06,420,305.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,305.27c-.52,4.12-5.39,6.88-10.91,6.16-4.87-.62-8.62-3.72-9.13-7.29.53-4.11,5.4-6.87,10.92-6.17C415.73,298.6,419.48,301.71,420,305.27Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "382.52 85.73 382.52 127.58 388.39 127.58 388.39 137.73 398.54 127.58 454.25 127.58 454.25 85.73 382.52 85.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52,85.73l.3,41.85-.3-.3,5.87,0h.33v.33l0,10.15-.64-.26,10.11-10.19c.19-.35,55.69-.08,56-.19l-.49.49.06-41.85.43.43-71.73-.43Zm0,0c.59.16,71.63-.54,72.15-.43v.43l.07,41.85v.49h-.49c.07-.17-56.8.2-55.41-.19L388.66,138l-.64.63v-.89l.05-10.15.32.32-5.87,0h-.3v-.3l.3-41.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.94,106.66a3.4,3.4,0,1,0,3.4-3.4A3.4,3.4,0,0,0,431.94,106.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,106.66a3.4,3.4,0,1,0,3.4-3.4A3.4,3.4,0,0,0,415,106.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,106.66a3.4,3.4,0,1,0,3.4-3.4A3.4,3.4,0,0,0,398,106.66Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotCuate);
export default __webpack_public_path__ + "static/media/Chat bot-cuate.f0e47d970f0ca3ef1123feb4814e5102.svg";
export { ForwardRef as ReactComponent };